import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, concatMap, mergeMap, toArray, tap } from 'rxjs/operators';
import { PETICIONES, STORAGE, LS_LANG, DEFAULT_LANG, LINKS_EXTERNAL, CODE_TOKEN_EXTERNO, MENSAJE_EXTERNO_LOGIN, MENSAJE_INICIO, PARAMETRES, TIPO_DATO, BASE_HREF, CODE_WEBSERVICES, ESTALVIA_TEMPS, EXTERNAL_ROL, ETIQUETAS, ACCESO_EXTERNAL, OPTIONAL_LANG, EXTERNAL_PAGES, OVT_GTT_LINK, OVT_GTT_LINK_ENABLED, PARAMS_OVT, XML_LINKS_EXTERNOS } from 'src/app/core/utils/constants';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { ParametersService } from 'src/app/core/repositories/parameters.service';
import { AvisService } from 'src/app/core/repositories/avis.service';
import { CommentsService } from 'src/app/core/repositories/comments.service';
import { Wsdefs } from 'src/app/core/entities/wsdefs.model';
import { Permissions } from 'src/app/core/entities/permissions.model';
import { Setvalues } from 'src/app/core/entities/setvalues.model';
import { TokenValid } from '../../../../core/auth/tokenvalid.model';
import { Webservice } from 'src/app/core/entities/webservice.model';
import { WebservicesParse } from 'src/app/core/entities/webservicesparse.model';
import { Parameters } from 'src/app/core/entities/parameters.model';
import { MensajeLogin } from 'src/app/core/entities/mensajelogin.model';
import { Texts } from 'src/app/core/entities/texts.model';
import { Xmlfields } from 'src/app/core/entities/xmlfields.model';
import { Notices } from 'src/app/core/entities/notices.model';
import { Rols } from 'src/app/core/entities/rols.model';
import { WebserviceValorDato } from 'src/app/core/entities/webservicevalordato.model';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import { Fieldlinks } from 'src/app/core/entities/fieldlinks.model';
import { Xmldefs } from 'src/app/core/entities/xmldefs.model';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { Representants } from 'src/app/core/entities/representants.model';
import { LastValoracio } from 'src/app/core/entities/lastValoracio.model';
import { Avis } from 'src/app/core/entities/avis.model';
import { Comments } from 'src/app/core/entities/comments.model';
import { Userprofile } from 'src/app/core/entities/userprofile.model';
import { BuscadorTramites } from 'src/app/core/entities/buscadortramites.model';
import { RepresentantsAOC } from 'src/app/core/entities/representantsaoc.model';
import { DataExternal } from 'src/app/core/entities/dataexternal.model';
import { RepresentaAccLog } from 'src/app/core/entities/representaacclog.model';
import { DialogsAvisosComponent } from 'src/app/shared/components/dialogs/dialogs-avisos/dialogs-avisos.component';
import { DialogsPerfilComponent } from 'src/app/shared/components/dialogs/dialogs-perfil/dialogs-perfil.component';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { DialogsBuscadorExternaComponent } from 'src/app/shared/components/dialogs/dialogs-buscador-externa/dialogs-buscador-externa.component';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsRepresentantAocComponent } from 'src/app/shared/components/dialogs/dialogs-representant-aoc/dialogs-representant-aoc.component';
import { AuxiliarAOC } from 'src/app/core/entities/auxiliaraoc.model';
import { StatisticsExternal } from 'src/app/core/entities/statisticsexternal.model';
import { StatisticsExternalService } from 'src/app/core/repositories/statisticsexternal.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class HomeExternalService {

  readonly SALIR: string = BASE_HREF + '/assets/images/logout.svg';
  readonly REUS_AYUDA: String = LINKS_EXTERNAL.REUS_AYUDA;
  readonly REUS_AYUDA_CAS: String = LINKS_EXTERNAL.REUS_AYUDA_CAS;
  readonly REUS_TUTORIAL: string = LINKS_EXTERNAL.REUS_TUTORIAL;
  readonly REUS_TUTORIAL_PROV_CA: string = LINKS_EXTERNAL.REUS_TUTORIAL_PROV_CA;
  readonly REUS_TUTORIAL_PROV_ES: string = LINKS_EXTERNAL.REUS_TUTORIAL_PROV_ES;
  readonly REUS_SEU: String = LINKS_EXTERNAL.REUS_SEU;
  readonly REUS_TRAM_ACOMPAN: String = LINKS_EXTERNAL.REUS_TRAMIT_ACOMPA;
  readonly REUS_INCIDENCIA: String = LINKS_EXTERNAL.REUS_INCIDENCIA;
  readonly REUS_INCIDENCIA_CAS: String = LINKS_EXTERNAL.REUS_INCIDENCIA_CAS;
  readonly REUS_REQUISITOS_GUIA: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA;
  readonly REUS_REQUISITOS_GUIA_ES: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA_ES;

  comment: Comments = new Comments();
  conversacion: Comments[] = new Array<Comments>();

  rol: string = "";
  value_msg_initial: string = "";
  nombre: string = "";
  nif: string = "";
  titulo: string = "";
  carpeta: string = "";
  idioma: string = "";
  ip: string = "";
  readonly PETICIONES = PETICIONES;

  items: MenuItem[] = [];
  datagroupAux: any = [];
  auxsetvalues: any = [];
  setvaluesOVT: Setvalues[] = new Array<Setvalues>();
  setvalues: Setvalues[] = new Array<Setvalues>();
  setvaluesBusca: Setvalues[] = new Array<Setvalues>();

  tercer: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
  tercerApoyo: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();
  persons: PersonsByIdNumCtrlDig = new PersonsByIdNumCtrlDig();
  optionsTercer: SelectItem[] = [];
  optionsTercerBase: SelectItem[] = [];

  idRepresentante: string = "";
  idRepresentanteAOC: string = "";
  dboidRepresentado: string = "";
  allrepres: Representants[] = new Array<Representants>();
  represApoyo: Representants[] = new Array<Representants>();
  repres: Representants = new Representants();
  optionsRepres: SelectItem[] = [];
  optionsRepresBase: SelectItem[] = [];

  allrepresOAC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
  represOACApoyo: RepresentantsAOC[] = new Array<RepresentantsAOC>();
  represOAC: RepresentantsAOC = new RepresentantsAOC();
  represeoaccheck: number = 0;
  represeoacllamada: number = 0;
  llamadaAux: number = 0;

  setvaluerol: Setvalues[] = new Array<Setvalues>();
  wsdefs: Wsdefs[] = new Array<Wsdefs>();
  wsdefsrol: Wsdefs[] = new Array<Wsdefs>();
  wsvistaprevia: Wsdefs[] = new Array<Wsdefs>();

  initial_text: Texts = new Texts();
  notices: Notices = new Notices();
  mensajeLogin: MensajeLogin[] = new Array<MensajeLogin>();

  permissions: Permissions[] = new Array<Permissions>();
  vista_rapida: Rols = new Rols();

  webservice: Webservice = new Webservice();
  vistaRapidaObj: VistaRapida = new VistaRapida();

  webservicesParse: WebservicesParse[] = new Array<WebservicesParse>();
  webservicesParseBuscador: WebservicesParse[] = new Array<WebservicesParse>();
  webservicesParseBuscadorAux: WebservicesParse[] = new Array<WebservicesParse>();
  webservicesParseDef: WebservicesParse[] = new Array<WebservicesParse>();
  webservicesParseVista: WebservicesParse[] = new Array<WebservicesParse>();
  webserviceVista: WebservicesParse = new WebservicesParse();

  xmldefs: Xmldefs[] = new Array<Xmldefs>();
  fieldLinks: Fieldlinks[] = new Array<Fieldlinks>();
  parameters_code_tk: Parameters = new Parameters();
  parameters_code_msg: Parameters = new Parameters();
  parameters_gtt_link: Parameters = new Parameters();
  parameters_gtt_enab: Parameters = new Parameters();
  parameters_lik_exter: Parameters = new Parameters();
  validToken: TokenValid = new TokenValid();
  xmlfieldBusca: Xmlfields[] = new Array<Xmlfields>();

  statistics : StatisticsExternal = new StatisticsExternal();
  isStatistics: boolean = false;

  repreinsert: RepresentaAccLog = new RepresentaAccLog();

  textContacte: boolean = false;
  loadingWS: boolean = true;
  vistaRapida: boolean = false;
  butonOrderColUp: boolean = true;
  butonOrderColDown: boolean = false;
  wsenabledrefresh: boolean = false;
  existNotif: boolean = false;
  existComun: boolean = false;
  bannerRefre: boolean = true;
  AOCRefresca: boolean = true;
  refrescoHeader: boolean = false;
  valorTrue: boolean = true;
  valorFalse: boolean = false;
  isTramite: boolean = false;
  fullBusca: boolean = false;

  numavis: number = 0; 
  numtramitbusqueda: number = 0;

  dateSesion: any = localStorage.getItem(STORAGE.DATE_ANT);
  diasSessionLabel: number = 0;

  imagePath: string = "";
  ayudaLang: String = "";
  incidencia: String = "";
  requisitos: String = "";
  tramitsbusqueda: string = "";
  gtturl: string = "";
  linkexter: string = "";

  viewfactures: boolean = false;
  viewContractes: boolean = false;
  viewgtturl: boolean = false;

  loadingfactures: boolean = true;
  loadingContractes: boolean = true;
  loadingTramite: boolean = true;

  arrayVal: WebserviceValorDato[][] = new Array<Array<WebserviceValorDato>>();
  arrayValApoyo: WebserviceValorDato[][] = new Array<Array<WebserviceValorDato>>();
  webQueixas: WebservicesParse = new WebservicesParse();
  webNotific: WebservicesParse = new WebservicesParse();
  webComunic: WebservicesParse = new WebservicesParse();

  lastvaloracion: LastValoracio[] = new Array<LastValoracio>();
  valoracion: boolean = true;

  allAvisUser: Avis[] = new Array<Avis>();
  allAvisEnable: Avis[] = new Array<Avis>();

  userProfile : Userprofile = new Userprofile();

  buscaTramAll: BuscadorTramites[] = new Array<BuscadorTramites>();
  numeroMensajes: number = 1;

  numCarpeta: number = 0;

  accesToken : string = "";
  user: string = "";

  tram_acomp_text: string = "";

  isNumeric = (value: any): boolean => !isNaN(Number(value));

  constructor(private translateService: TranslateService,
              private repositoryService: RepositoryService,
              private parametersService: ParametersService,
              private statisticsExternalService: StatisticsExternalService,
              private avisService: AvisService,
              private dialog: MatDialog,
              private datePipe: DatePipe,
              public router: Router,
              private sanitizer: DomSanitizer,
              private commentsService: CommentsService,
              public http: HttpClient) {
                this.vistaRapida = false;
              }

  initView(data: string, objetoexterno: DataExternal): Observable<any> {

    if(objetoexterno.representantAOC != null && objetoexterno.representantAOC.carpeta != ""){
      data = _.cloneDeep(objetoexterno.representantAOC.carpeta);
    }

    this.optionsTercer = [];
    this.optionsTercerBase = [];

    this.buscaTramAll = new Array<BuscadorTramites>();
    this.webservicesParseDef = new Array<WebservicesParse>();
    this.tramitsbusqueda = "";

    let agent = btoa(window.navigator.userAgent);
    this.ip = _.cloneDeep(localStorage.getItem(STORAGE.IP) ?? '');
    
    this.textContacte = false;
    this.loadingWS = true;
    this.vistaRapida = true;
    this.isTramite = false;
    this.viewfactures = false;
    this.viewContractes = false;
    this.viewgtturl = false;
    this.fullBusca = false;

    this.vistaRapidaObj.padroenable = false;

    this.webQueixas = new WebservicesParse();
    this.webNotific = new WebservicesParse();
    this.webComunic = new WebservicesParse();

    this.wsdefsrol = new Array<Wsdefs>();
    this.wsvistaprevia = new Array<Wsdefs>();
    this.setvaluerol = new Array<Setvalues>();

    let stringToken = localStorage.getItem(STORAGE.VALID_TOKEN);
    this.validToken = stringToken ? JSON.parse(stringToken) : null;

    this.accesToken = _.cloneDeep(this.validToken.token);
    this.user = this.validToken.identifier;

    this.tram_acomp_text = this.translateService.instant("WEBSERVICES.VISTA_RAPIDA.txt_tramit");

    /* Para cuando queramos entrar directamente al home... al tener el validToken a null lo redirige a acces*/
    if(this.validToken === null){
      this.router.navigate(['/external/acces']);
    }

    //localStorage.setItem(STORAGE.DBOID, objetoexterno.dboid);
    let dboidActual = objetoexterno.dboid ?? "";

    if(objetoexterno.representantAOC != null && objetoexterno.representantAOC.carpeta != ""){
      this.rol = objetoexterno.representantAOC.carpeta;
    }else{
      this.rol = data;
    }

    if(this.llamadaAux != 3){
      this.nif = this.validToken.identifier;
    }
    this.llamadaAux = 0;

    if(this.validToken.certificateType === 'J'){
      this.nif = _.cloneDeep(this.validToken.companyId);
    }

    this.tercer = _.cloneDeep(objetoexterno.tercer);
    this.tercerApoyo = _.cloneDeep(objetoexterno.tercer);

    /**Metemos el nombe del usuario segun usuario */
    if(this.tercer.length > 0){
      this.nombre = this.tercer[0].nommostrar;
    }else{
      this.nombre = localStorage.getItem(STORAGE.USUARIO) ?? '';
    }
    if(this.validToken.certificateType === 'J'){
      this.nombre = _.cloneDeep(this.validToken.companyname);
    }

    this.allrepres = _.cloneDeep(objetoexterno.representants);
    this.represApoyo = _.cloneDeep(objetoexterno.representants);
    this.allrepresOAC = _.cloneDeep(objetoexterno.representantsAOC);
    this.represOACApoyo = _.cloneDeep(objetoexterno.representantsAOC);
    this.idRepresentante = _.cloneDeep(objetoexterno.representant ?? '');

    if(objetoexterno.representantAOC != null){
      this.idRepresentanteAOC = _.cloneDeep(objetoexterno.representantAOC.identificador);
      this.represeoaccheck = objetoexterno.representantAOC.check;
      this.represeoacllamada = objetoexterno.representantAOC.llamada;

      /*SI ES REFRESCO*/
      if(objetoexterno.representantAOC.check == null){
        //this.dboidRepresentado = localStorage.getItem(STORAGE.DBOID) ?? '';
        this.dboidRepresentado = dboidActual;
        if(this.nif === this.tercer[0].nif){
          this.represeoaccheck = 1;
        }else{
          this.represeoaccheck = 2;
        }
      /*SI ES EL TITULAR*/
      }else if(objetoexterno.representantAOC.check == 1){
        this.dboidRepresentado = _.cloneDeep(this.tercer[0].dboid);
      /*SI ES EL REPRESENTADO*/
      }else{
        this.dboidRepresentado = objetoexterno.representantAOC.dboid
      }
    }else{
      this.represeoaccheck = 1;
    }

    /*Variable donde recogemosel idioma */
    this.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;

    switch(this.rol){
      case EXTERNAL_ROL.PAGES.ciudadano: {
        this.titulo = ACCESO_EXTERNAL.ciudadano.title;
        this.carpeta = EXTERNAL_PAGES.PAGES.ciudadano;
        this.numCarpeta = 2;
        break;
      }
      case EXTERNAL_ROL.PAGES.proveedor: {
        this.titulo = ACCESO_EXTERNAL.proveedor.title;
        this.carpeta = EXTERNAL_PAGES.PAGES.proveedor;
        this.numCarpeta = 4;
        break;
      }
      case EXTERNAL_ROL.PAGES.empresa: {
        this.titulo = ACCESO_EXTERNAL.empresa.title;
        this.carpeta = EXTERNAL_PAGES.PAGES.empresa;
        this.numCarpeta = 3;
        break;
      }
    }


    if(this.allrepresOAC === null){
      if(this.idRepresentante === null){
        /*Gestor del selector de tercer*/
        for (let i = 0; i < this.tercer.length; i++) {
          //if(this.tercer[i].dboid === localStorage.getItem(STORAGE.DBOID)){
          if(this.tercer[i].dboid === dboidActual){
              this.persons = this.tercer[i];
          }
          this.optionsTercerBase.push({ value: this.tercer[i].dboid, label: this.tercer[i].fullname });
        }
        this.optionsTercer = this.optionsTercerBase;
        this.optionsTercerBase = [];
      }else{
        /*Gestor del selector de representantes*/
        for (let i = 0; i < this.allrepres.length; i++) {
          if(this.allrepres[i].entitatcodi === this.idRepresentante){
              this.repres = this.allrepres[i];
          }
          this.optionsRepresBase.push({ value: this.allrepres[i].entitatcodi, label: this.allrepres[i].entitatnom });
        }
        this.optionsRepres = this.optionsRepresBase;
        this.optionsRepresBase = [];

        localStorage.setItem(STORAGE.DBOID, this.repres.entitatdboid);
        this.nif = this.repres.entitatcif;
      }
    }else{
      /*Gestor del selector de representantes AOC*/
      for (let i = 0; i < this.allrepresOAC.length; i++) {
        if(this.allrepresOAC[i].identificadorlegal === this.idRepresentanteAOC){
            this.represOAC = this.allrepresOAC[i];
        }
      }
      if(objetoexterno.representantAOC?.check == 1){
        this.nif = objetoexterno.representantsAOC[0].representantdocident;
      }else if(objetoexterno.representantAOC?.check == 2){
        this.nif = this.represOAC.poderdantdocident;
      }else{
        //this.nif = this.represOAC.poderdantdocident;
        this.nif = _.cloneDeep(this.nif);
      }
      
      if(this.AOCRefresca){
        //localStorage.setItem(STORAGE.DBOID, this.dboidRepresentado);
        localStorage.setItem(STORAGE.DBOID, dboidActual);
        this.nif = _.cloneDeep(this.nif);
      }
    }

    this.diasSession();

    let toReturnImage: string = "";
    this.imagePath = 'data:image/jpg;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(toReturnImage) as any).changingThisBreaksApplicationSecurity;

    /*registro auditoria consultas de los usuarios extennos*/ 
    this.statistics.rol = this.rol;
    this.statistics.nifinteressat = this.nif.toLocaleUpperCase();
    this.statistics.nifrepresentant = this.tercer[0].nif.toLocaleUpperCase();
    this.statistics.ip = this.ip;
    this.statistics.createdAt = new Date();

    /*registro almacenamiento como representante de los usuarios extennos*/ 
    if(this.represeoaccheck == 2){
      console.log("HE ENTRADO COMO REPRESENTANTE A LOS DATOS DE MI REPRESENTADO");
      this.repreinsert.idApp = this.numCarpeta;
      this.repreinsert.numDocRepr = this.nif.toLocaleUpperCase();
      this.repreinsert.numDocTer = this.tercer[0].nif.toLocaleUpperCase();
      this.repreinsert.dataLog = new Date();
    }else{
      console.log("HE ENTRADO CON MI CARPETA");
      this.repreinsert = new RepresentaAccLog();
    }

    return forkJoin({
          peticion00: this.repositoryService.doGet(PETICIONES.setvalues.findAll),
          peticion01: this.repositoryService.doGet(PETICIONES.wsdefs.findAll),
          peticion02: this.repositoryService.doGet(PETICIONES.permissions.findAll),
          peticion03: this.parametersService.findByCode(CODE_TOKEN_EXTERNO),
          peticion04: this.parametersService.findByCode(MENSAJE_EXTERNO_LOGIN),
          peticion05: this.repositoryService.findByCode(PETICIONES.texts.findByCode, MENSAJE_INICIO),
          peticion06: this.repositoryService.findByCode(PETICIONES.notices.findByCode, ESTALVIA_TEMPS),
          peticion07: this.repositoryService.findByCode(PETICIONES.rols.findByCode, this.rol),
          peticion08: this.repositoryService.doGet(PETICIONES.webservice.doGetLogin + "/" + this.nif + "/" +  this.idioma),
          peticion09: this.repositoryService.doGet(PETICIONES.fieldlinks.findAll),
          peticion10: this.repositoryService.doGet(PETICIONES.xmldefs.findAll),
          peticion11: this.avisService.findByDboid(dboidActual),
          peticion12: this.repositoryService.findByCode(PETICIONES.userprofile.findByIdentifier, this.nif),
          peticion13: this.repositoryService.doGet(PETICIONES.xmlfields.findAll),
          peticion14: this.statisticsExternalService.postStatisticsExternal(this.statistics),
          peticion15: this.parametersService.findByCode(OVT_GTT_LINK),
          peticion16: this.parametersService.findByCode(OVT_GTT_LINK_ENABLED),
          peticion17: this.parametersService.findByCode(XML_LINKS_EXTERNOS),
          peticion18: this.repositoryService.doPost(PETICIONES.representaAccLog.postRepresentaAccLogSecuencia, this.repreinsert)
    }).pipe( map((dataGroup) => {
            this.datagroupAux = dataGroup;
            this.auxsetvalues = _.cloneDeep(dataGroup.peticion00);
            this.setvaluesOVT = _.cloneDeep(dataGroup.peticion00);
            this.wsdefs = _.cloneDeep(dataGroup.peticion01);
            this.permissions = _.cloneDeep(dataGroup.peticion02);

            /*Recogemos el objeto parametre con el parametro del token (atributo value) para llamar a los WS*/
            this.parameters_code_tk = _.cloneDeep(dataGroup.peticion03 as Parameters);
            if(this.parameters_code_tk === null){
              this.loadingWS = false;
              return null;
            }

            this.parameters_code_msg = _.cloneDeep(dataGroup.peticion04 as Parameters);
            this.initial_text = _.cloneDeep(dataGroup.peticion05);
            this.notices = _.cloneDeep(dataGroup.peticion06);
            this.vista_rapida = _.cloneDeep(dataGroup.peticion07);

             /*Pasamos la url que nos dará la respuesta del mensaje que viene con el login*/
            this.mensajeLogin = _.cloneDeep(dataGroup.peticion08);

            this.fieldLinks = _.cloneDeep(dataGroup.peticion09);
            this.xmldefs = _.cloneDeep(dataGroup.peticion10);

            /**Gestion de los avisos**/
            let allAvis = new Array<Avis>();
            this.allAvisUser = new Array<Avis>();
            this.allAvisEnable = new Array<Avis>();
            allAvis = _.cloneDeep(dataGroup.peticion11 as Avis[]);
            if(allAvis.length > 0){
              for(let i = 0; i < allAvis.length; i++){
                if(allAvis[i].avisEstat.id === 3 || allAvis[i].avisEstat.id === 5){
                  //this.allAvisUser.push(allAvis[i]);
                  if(allAvis[i].avRead === 0){
                    this.allAvisUser.push(allAvis[i]);
                    this.allAvisEnable.push(allAvis[i]);
                  }
                }
              }
            }
            this.allAvisUser = _.orderBy(this.allAvisUser, 'dateCreation').reverse();

            /**Gestion del idioma en le perfil**/
            this.userProfile = _ .cloneDeep(dataGroup.peticion12);
            /*Si no hay perfil de idioma no se hace nada*/
            if(this.userProfile != null){
              /*El idioma es distinto al del perfil de usuario*/
              if(localStorage.getItem(LS_LANG) || DEFAULT_LANG != this.userProfile.lang){
                let lenguaje = "";
                if(!this.refrescoHeader){
                  /*El usuario viene de inicio*/
                  lenguaje = this.userProfile.lang;
                  this.idioma =_.cloneDeep(this.userProfile.lang);
                }else{
                  /*El usuario viene de cambiar idioma en la cabecera*/
                  lenguaje = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
                  this.idioma =_.cloneDeep(lenguaje);
                }
                this.translateService.setDefaultLang(lenguaje);
                this.translateService.use(lenguaje);
                localStorage.setItem(LS_LANG, lenguaje);
                Utils.changeStyleTranslate();
                this.refrescoHeader = false;
              }
            }

            this.xmlfieldBusca = _.cloneDeep(dataGroup.peticion13);
            /**Getión de asistente personal */
            /*this.conversacion = _.cloneDeep(dataGroup[13]);
            console.log(this.conversacion);*/

            this.isStatistics = _.cloneDeep(dataGroup.peticion14 as boolean);
            if(this.isStatistics){
                console.log("consulta de rol: " + this.rol + " al Nº identif: " + this.nif.toLocaleUpperCase());
            }

            this.parameters_gtt_link = _.cloneDeep(dataGroup.peticion15 as Parameters);
            this.gtturl = this.parameters_gtt_link.value;

            this.parameters_gtt_enab = _.cloneDeep(dataGroup.peticion16 as Parameters);
            this.viewgtturl = (this.parameters_gtt_enab.value == "0");

            this.parameters_lik_exter = _.cloneDeep(dataGroup.peticion17 as Parameters);
            this.linkexter = this.parameters_lik_exter.value;

            /** Buscamos idioma en el localstorage y lo asignamos a los valores según escoja el usuario */
            let lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
            if(lang === 'es'){
                this.value_msg_initial = this.initial_text.valueesp;
                this.notices.title.code = this.notices.title.valueesp;
                this.notices.description.code = this.notices.description.valueesp;
                this.notices.text_button.code = this.notices.text_button.valueesp;
                this.ayudaLang = this.REUS_AYUDA_CAS;
                this.incidencia = this.REUS_INCIDENCIA_CAS;
                this.requisitos = this.REUS_REQUISITOS_GUIA_ES;
            }else{
                this.value_msg_initial = this.initial_text.valuecat;
                this.notices.title.code = this.notices.title.valuecat;
                this.notices.description.code = this.notices.description.valuecat;
                this.notices.text_button.code = this.notices.text_button.valuecat;
                this.ayudaLang = this.REUS_AYUDA;
                this.incidencia = this.REUS_INCIDENCIA;
                this.requisitos = this.REUS_REQUISITOS_GUIA;
            }

            //Recogemos los webservices que pertenecen al usuario con el rol seleccionado.
            for(let i = 0; i < this.permissions.length; i++){
              if(this.rol === this.permissions[i].rolId.code && this.permissions[i].operationId.code === "GET"){
                for(let x = 0; x < this.wsdefs.length; x++){
                  /* WS que utilizaremos para formar vista rápida*/
                  if(this.wsdefs[x].online === 1){
                      if(this.permissions[i].permissionableId === this.wsdefs[x].id){
                          this.wsvistaprevia.push(this.wsdefs[x]);
                      }
                  }
                  /* WS que se verán en el menu de selección de webservices*/
                  if(this.wsdefs[x].online === 1 && (this.wsdefs[x].quickview === 0 || this.wsdefs[x].quickview === 2)){
                      if(this.permissions[i].permissionableId === this.wsdefs[x].id){
                          this.wsdefsrol.push(this.wsdefs[x]);
                      }
                  }
                }
              }
            }

            /*Creamos un objeto WebservicesParse con todos los ws del rol seleccionado*/
            this.webservicesParseBuscadorAux = new Array<WebservicesParse>();
            for(let i = 0; i < this.wsdefsrol.length; i++){
                this.webservicesParseBuscadorAux .push(new WebservicesParse());
                this.webservicesParseBuscadorAux [i].cat = _.cloneDeep(this.wsdefsrol[i].cat);
                this.webservicesParseBuscadorAux [i].esp = _.cloneDeep(this.wsdefsrol[i].esp);
                this.webservicesParseBuscadorAux [i].code = _.cloneDeep(this.wsdefsrol[i].code);
                let xmlfield =  new Array<Xmlfields>();
                let permisos =  new Array<Permissions>();
                for(let x = 0; x < this.xmlfieldBusca.length; x++){
                    if(this.wsdefsrol[i].xmldef.id === this.xmlfieldBusca[x].xmldefId){
                        for(let y = 0; y < this.permissions.length; y++){
                            if(this.permissions[y].permissionableType === "Xmlfield" && this.permissions[y].operationId.code === "VIEW"){
                                if(this.permissions[y].rolId.code === this.rol){
                                    if(this.xmlfieldBusca[x].id === this.permissions[y].permissionableId){
                                        xmlfield.push(this.xmlfieldBusca[x]);
                                        permisos.push(this.permissions[y]);
                                    }
                                }
                            }
                        }
                    }
                }
                this.webservicesParseBuscadorAux [i].etiquetas = _.cloneDeep(xmlfield);
                this.webservicesParseBuscadorAux [i].permisos = _.cloneDeep(permisos);
            }

            /*Recogemos los setvalues que pertenecen al usuario con el rol seleccionado*/
            var newSetValues: Setvalues[] = [];
            var lookupObject: Record<number, Setvalues> = {};
            for(let a = 0; a < this.wsdefsrol.length; a++){
              this.setvaluerol.push(this.wsdefsrol[a].setvalue);
            }

            for(var b in this.setvaluerol) {
              lookupObject[this.setvaluerol[b].id] = this.setvaluerol[b];
            }

            for(var c in lookupObject) {
              newSetValues.push(lookupObject[c]);
            }

            this.setvalues = _.cloneDeep(newSetValues);

            /**Recogemos en un array los WS con enabled desactivado o que sean de vista rápida**/
            let wsdefsrolenabled= new Array<Wsdefs>();
            for(let i = 0; i < this.wsvistaprevia.length; i++){
              if(this.wsvistaprevia[i].enable === 1 || this.wsvistaprevia[i].quickview === 2 || this.wsvistaprevia[i].quickview === 1){
                  wsdefsrolenabled.push(this.wsvistaprevia[i]);
              }
            }

            /**Sacamos fuera el ws de contratos y facturas porque no se carga de inicio (carga lenta); carga del usuario **/
            for(let j = 0; j < wsdefsrolenabled.length; j++){
              if(wsdefsrolenabled[j].code === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
                  wsdefsrolenabled.splice(j, 1);
              }
              if(wsdefsrolenabled[j].code === CODE_WEBSERVICES.PASFACTULTANYWSI){
                  wsdefsrolenabled.splice(j, 1);
              }
            }

            this.existNotif = false;
            this.existComun = false;

            /*Rellenamos el objeto webservice para pasarselo al servidor*/
            this.webservice.wsdefs = wsdefsrolenabled;
            this.webservice.nifcif = this.nif;
            this.webservice.dboid = localStorage.getItem(STORAGE.DBOID) ?? '';
            this.webservice.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
            this.webservice.codEmpresa = PARAMETRES.COD_EMPRESA;
            this.webservice.token = this.parameters_code_tk.value;
            this.webservice.permisos = this.permissions;
            this.webservice.rol = this.rol;

            this.webservice.userId = "";
            this.webservice.tokenacces = "";

            /*Pasamos los datos de todos los ws al servidor con un post*/
            this.repositoryService.doPost(PETICIONES.webservice.doPost, this.webservice).subscribe(data => {

              //this.webservicesParse = this.addVisibility(data);
              this.webservicesParse = this.formatTipoWS(data);

              /*clonamos el objeto webservicesParse para integralo en la vista rapida*/
              this.webservicesParseVista = _.cloneDeep(this.webservicesParse);
              if(this.webservicesParseVista.length > 0){

                this.vistaRapidaObj.active = true;

                let numws : number = 0;
                for(let i = 0; i < this.webservicesParseVista.length; i++){
                  numws++;
                  switch(this.webservicesParseVista[i].code.trim()) {
                    case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB: {
                      let numorden : number = 0;
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.WSAVISOSHABITANTEPOB, i, numorden, numws, ETIQUETAS.NOMBRE.textcarpcat);
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.WSAVISOSHABITANTEPOB, i, numorden, numws, ETIQUETAS.NOMBRE.textcarpesp);
                      
                      for(let p = 0; p < this.webservicesParse.length; p++){
                          if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                              this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                          }
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.TRAMITSPORTALCIUTADA:
                    case CODE_WEBSERVICES.TRAMITSPORTALEMPRESA:
                    case CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR: {                  
                      for(let p = 0; p < this.webservicesParse.length; p++){
                          if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                              this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                          }
                      }

                      this.vistaRapidaObj.totTramit = 0;
                      if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totTramit = this.webservicesParseVista[i].valores.length;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.ALTRESSERVEISCIUTADA:
                    case CODE_WEBSERVICES.ALTRESSERVEISEMPRESA:
                    case CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR: {
                      for(let p = 0; p < this.webservicesParse.length; p++){
                          if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                              this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                          }
                      }

                      this.vistaRapidaObj.totAltres = 0;
                      if(this.webservicesParseVista[i].valores != null){
                          this.vistaRapidaObj.totAltres = this.webservicesParseVista[i].valores.length;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.ESBORRANYSTRAMITS: {     
                      let numetiquetas = this.webservicesParseVista[i].etiquetas.length;
                      if(this.webservicesParseVista[i].valores != null){
                        this.webservicesParseVista[i].valores = this.ordenarPorFecha(this.webservicesParseVista[i].valores, numetiquetas);
                      }
                      
                      for(let p = 0; p < this.webservicesParse.length; p++){
                          if(this.webservicesParse[p].code === this.webservicesParseVista[i].code){
                              this.webservicesParse[p] = _.cloneDeep(this.webservicesParseVista[i]);
                          }
                      }
                      
                      this.vistaRapidaObj.totEsbor = 0;
                      if(this.webservicesParseVista[i].valores != null){
                          this.vistaRapidaObj.totEsbor = this.webservicesParseVista[i].valores.length;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.NOTIFICACIONSBYNIF: {
                      this.vistaRapidaObj.totNotifi = 0;
                      if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totNotifi = this.webservicesParseVista[i].valores.length;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.QUEIXESBYNIF: {
                      this.vistaRapidaObj.totQuejas = 0;
                      let numorden : number = 0;
                      this.webQueixas = new WebservicesParse();
                      this.arrayVal =  new Array<Array<WebserviceValorDato>>();
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.QUEIXESBYNIF, i, numorden, numws, ETIQUETAS.NOMBRE.datacreacio);
                      this.webQueixas = _.cloneDeep(this.webservicesParseVista[i]);
                      this.webQueixas.valores = _.cloneDeep(this.arrayVal);
                      if(this.webQueixas.valores != null){
                        this.vistaRapidaObj.totQuejas = this.webQueixas.valores.length;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.NOTCOMVIGWSI: {
                      this.vistaRapidaObj.totNotVig = 0;
                      this.vistaRapidaObj.totComVig = 0;

                      this.webNotific = new WebservicesParse();
                      this.webComunic = new WebservicesParse();

                      this.arrayVal =  new Array<Array<WebserviceValorDato>>();
                      this.arrayValApoyo =  new Array<Array<WebserviceValorDato>>();

                      let numorden : number = 0;
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NOTCOMVIGWSI, i, numorden, numws, ETIQUETAS.NOMBRE.tipus);
                      this.webNotific = _.cloneDeep(this.webservicesParseVista[i]);
                      this.webComunic = _.cloneDeep(this.webservicesParseVista[i]);
                      this.webNotific.valores = _.cloneDeep(this.arrayVal);
                      this.webComunic.valores = _.cloneDeep(this.arrayValApoyo);
                      break;
                    }
                    case CODE_WEBSERVICES.REBUTSULTANYWSI: {
                      this.vistaRapidaObj.totRebuts = 0;
                      this.vistaRapidaObj.totImportRebuts = 0;
                      this.vistaRapidaObj.totRebutPag = 0;
                      this.vistaRapidaObj.totRebutPenDins = 0;
                      this.vistaRapidaObj.totRebutPenFora = 0;
                      this.vistaRapidaObj.totRebutTramtit = 0;
                      this.vistaRapidaObj.totRebutAnul = 0;
                      this.vistaRapidaObj.rebutpagat = 0;
                      this.vistaRapidaObj.reubupendins = 0;
                      this.vistaRapidaObj.reubupenfora = 0;
                      this.vistaRapidaObj.tramitantse = 0;
                      this.vistaRapidaObj.rebutanul = 0;
                      let numorden : number = 0;
                      if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totRebuts = this.webservicesParseVista[i].valores.length;
                      }
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.REBUTSULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.recimport);
                      if(this.vistaRapidaObj.totRebutAnul != 0){
                        this.vistaRapidaObj.totRebuts = this.vistaRapidaObj.totRebuts - this.vistaRapidaObj.totRebutAnul;
                      }
                      if(this.vistaRapidaObj.rebutanul != 0){
                        this.vistaRapidaObj.totImportRebuts = this.vistaRapidaObj.totImportRebuts - this.vistaRapidaObj.rebutanul;
                      }
                      break;
                    }
                    case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                      this.vistaRapidaObj.totFacturas = 0;
                      this.vistaRapidaObj.totFacPag = 0;
                      this.vistaRapidaObj.totFacPend = 0;
                      this.vistaRapidaObj.totFacIncid = 0;
                      this.vistaRapidaObj.totImportFact = 0;
                      this.vistaRapidaObj.factpagat = 0;
                      this.vistaRapidaObj.factincid = 0;
                      this.vistaRapidaObj.factpende = 0;
                      let numorden : number = 0;
                      if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totFacturas = this.webservicesParseVista[i].valores.length;
                      }
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASFACTULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                      break;
                    }
                    case CODE_WEBSERVICES.PASEXPEDULTANYWSI: {
                      let numorden : number = 0;
                      this.vistaRapidaObj.totExped = 0;
                      this.vistaRapidaObj.totExpedAjud = 0;
                      this.vistaRapidaObj.totExpedTrib = 0;
                      this.vistaRapidaObj.totExpedSanc = 0;
                      this.vistaRapidaObj.totExpedAltr = 0;
                      this.vistaRapidaObj.expedCurso = 0;
                      this.vistaRapidaObj.expedFinal = 0;
                      this.vistaRapidaObj.expedAjud = 0;
                      this.vistaRapidaObj.expedTrib = 0;
                      this.vistaRapidaObj.expedSanc = 0;
                      this.vistaRapidaObj.expedAltr = 0;
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASEXPEDULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.carpnomestat);
                      if(this.webservicesParseVista[i].valores != null){
                           this.vistaRapidaObj.totExped = this.webservicesParseVista[i].valores.length;
                      }
                      break;
                    }

                    case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                      let numorden : number = 0;
                      this.vistaRapidaObj.totContra = 0;
                      this.vistaRapidaObj.totImportContr = 0;
                      this.vistaRapidaObj.contImporFac = 0;
                      this.vistaRapidaObj.contImporNotFac = 0;
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NIOSDISPONIBLESPROV, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                      if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totContra = this.webservicesParseVista[i].valores.length;
                      }
                      this.vistaRapidaObj.contImporFac = this.vistaRapidaObj.totImportContr - this.vistaRapidaObj.contImporNotFac;
                      break;
                    }
                    case CODE_WEBSERVICES.DADESCONTACTE: {
                      let numorden : number = 0;
                      this.vistaRapidaObj.email = "-";
                      this.vistaRapidaObj.movil = "-";
                      this.vistaRapidaObj.telefono = "-";
                      this.vistaRapidaObj.fax = "-";
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.DADESCONTACTE, i, numorden, numws, ETIQUETAS.NOMBRE.tipus);
                      break;
                    }
                    case CODE_WEBSERVICES.VRWSPASHABITADADESWSI: {
                      let numorden : number = 0;
                      this.vistaRapidaObj.individual = "";
                      this.vistaRapidaObj.colectivo = "";
                      this.vistaRapidaObj.padroenable = true;
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.VRWSPASHABITADADESWSI, i, numorden, numws, ETIQUETAS.NOMBRE.individual);
                      this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.VRWSPASHABITADADESWSI, i, numorden, numws, ETIQUETAS.NOMBRE.colectivo);
                      break;
                    }
                  }

                }
              }

              /*LIMPEZA WS SIN DATOS EN CARGA INICIAL*/
              let setvaluesLimpios = new Array<Setvalues>();
              let webservicesvacios = new Array<WebservicesParse>();
              for(let d = 0; d < this.setvalues.length; d++){
                if (this.setvalues[d]?.wsdefs?.length > 0) {
                  setvaluesLimpios.push(this.setvalues[d]);
                }
              }

              for(let d = 0; d < setvaluesLimpios.length; d++){
                for(let f = 0; f < setvaluesLimpios[d].wsdefs.length; f++){
                  for(let g = 0; g < this.webservicesParseVista.length; g++){
                    if(setvaluesLimpios[d].wsdefs[f].code === this.webservicesParseVista[g].code){
                      if(this.webservicesParseVista[g].valores == null){
                        webservicesvacios.push(this.webservicesParseVista[g]);
                      }
                    }
                  }
                }
              }

              for (let d = 0; d < this.setvalues.length; d++) {
                for (let e = 0; e < this.setvalues[d].wsdefs.length; e++) {
                    for (let f = 0; f < webservicesvacios.length; f++) {
                        if (this.setvalues[d].wsdefs[e] && this.setvalues[d].wsdefs[e].code === webservicesvacios[f].code) {
                            this.setvalues[d].wsdefs.splice(e, 1);
                            e--;
                        }
                    }
                }
              }

              /**INTEGRACIÓN LINKS EN ESTRUCTURA WSDEFS**/
              for (let x = 0; x < this.wsdefs.length; x++) {
                if(this.wsdefs[x].xmldef.code === this.linkexter && this.wsdefs[x].online == 1){
                  for (let j = 0; j < this.setvalues.length; j++) {
                    if(this.setvalues[j].code === this.wsdefs[x].setvalue.code){
                      if (!this.setvalues[j].wsdefs) {
                        this.setvalues[j].wsdefs = []; // Inicializar wsdefs como un arreglo vacío si no existe
                      }
                      /*ASIGNACION DE LOS PERMISOS */
                      for(let i = 0; i < this.permissions.length; i++){
                        if(this.rol === this.permissions[i].rolId.code && this.permissions[i].operationId.code === "GET"){
                          if(this.wsdefs[x].online === 1){
                            if(this.permissions[i].permissionableId === this.wsdefs[x].id){
                              this.setvalues[j].wsdefs.push(this.wsdefs[x]);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              for (let j = 0; j < this.setvalues.length; j++) {
                if (this.setvalues[j].wsdefs.length == 0) {
                  this.setvalues.splice(j, 1);
                  j--;
                }
              }

              this.setvalues = _.orderBy(this.setvalues, 'numorder');

              this.setvaluesBusca = _.cloneDeep(this.setvalues);
              this.loadingWS = false;
            }, error => {
              console.log("Error: " + error);
              this.loadingWS = false;
            });

            return dataGroup;
          }),
            concatMap((dataGroup) => dataGroup?.peticion00),
            mergeMap((item) => this.getWsdef(item)),
            map(variable => variable),
            toArray(),
            tap((variable) => {
            this.assignWsdefsToSetvalue(variable);
            this.datagroupAux.listaWsdefs = variable;
            return this.datagroupAux;
          }))
          .pipe(map(res => this.datagroupAux),
          catchError((error: any) => {
            console.log(error);
            throw error;
          }));
  }

  /**
  * Función para calcular los distintos valores de los distintos apartados de la vista rápida
  * @param ws listado de valores que nos traemos de los WS
  * @param code codigo del wdefs
  * @param numWsVr posicion del objeto que nos traemos dentro de la lista de objetos.
  * @param numorden utilizado para localizar el posicionamiento de etiquetas
  * @param numws utilizado para localizar el posicionamiento de los valores.
  * @param etiqueta etiqueta a la que iremos a buscar el valor.
  */
  public calculoImportes(ws: WebservicesParse[], code: string, numWsVr: number, numorden: number, numws: number, etiqueta: string){
    for(let x = 0; x < ws[numWsVr].etiquetas.length; x++){
      /*control posicionamiento etiquetas tramites*/
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.desctramit){
          this.vistaRapidaObj.posiciodescat = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.detTramit){
          this.vistaRapidaObj.posiciodetacat = ws[numWsVr].etiquetas[x].numorder;
      }
      /*control posicionamiento etiquetas otros servicios*/
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.descripcio){
          this.vistaRapidaObj.posicioaltdescat = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.detall){
          this.vistaRapidaObj.posicioaltdetacat = ws[numWsVr].etiquetas[x].numorder;
      }

      /*control posicionamiento etiquetas avisos multiidioma*/
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.textcarpcat){
        this.vistaRapidaObj.textcarpcat = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.textcarpesp){
        this.vistaRapidaObj.textcarpesp = ws[numWsVr].etiquetas[x].numorder;
      }

      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.estat_calcul){
        this.vistaRapidaObj.posiciorebutestat = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.estatvrfactura){
        this.vistaRapidaObj.posiciofact = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.importepte){
        this.vistaRapidaObj.posiciocontrac = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.descripcio){
        this.vistaRapidaObj.posicioDescrip = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.datacreacio){
        this.vistaRapidaObj.posiciofecha = ws[numWsVr].etiquetas[x].numorder;
      }
      if(ws[numWsVr].etiquetas[x].code.trim() === ETIQUETAS.NOMBRE.categcodi){
        this.vistaRapidaObj.posicioexped = ws[numWsVr].etiquetas[x].numorder;
      }
    }
    if(ws[numWsVr].valores != null){
        for(let x = 0; x < ws[numWsVr].etiquetas.length; x++){
            numorden = 0;
            if(ws[numWsVr].etiquetas[x].code.trim() == etiqueta){
                numorden = ws[numWsVr].etiquetas[x].numorder;
                for(let z = 0; z < ws[numws - 1].valores.length; z++){
                    for(let y = 0; y < ws[numws - 1].valores[z].length; y++){
                        if(numorden == ws[numws - 1].valores[z][y].numorder){
                            switch(code) {
                                case CODE_WEBSERVICES.REBUTSULTANYWSI: {
                                  /** calculo del importe total; de momento dentro de valor etiquetas hasta que se solucione problema */
                                  this.vistaRapidaObj.totImportRebuts = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportRebuts;
                                  /**calculo del importe por estado del recibo */
                                  for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                    if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciorebutestat){
                                      let estat = ws[numws - 1].valores[z][t].valor;
                                      switch(estat){
                                          case ETIQUETAS.VALORES.REBUTSESTAT.pe:{
                                              this.vistaRapidaObj.reubupenfora = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.reubupenfora;
                                              this.vistaRapidaObj.totRebutPenFora++;
                                              break;
                                          }
                                          case ETIQUETAS.VALORES.REBUTSESTAT.pvdt:{
                                              this.vistaRapidaObj.reubupendins = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.reubupendins;
                                              this.vistaRapidaObj.totRebutPenDins++;
                                              break;
                                          }
                                          case ETIQUETAS.VALORES.REBUTSESTAT.c:{
                                              this.vistaRapidaObj.rebutpagat = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutpagat;
                                              this.vistaRapidaObj.totRebutPag++;
                                              break;
                                          }
                                          case ETIQUETAS.VALORES.REBUTSESTAT.tr:
                                          case ETIQUETAS.VALORES.REBUTSESTAT.pvft:
                                          case ETIQUETAS.VALORES.REBUTSESTAT.pvte:{
                                              this.vistaRapidaObj.tramitantse = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.tramitantse;
                                              this.vistaRapidaObj.totRebutTramtit++;
                                              break;
                                          }
                                          case ETIQUETAS.VALORES.REBUTS.a:{
                                              this.vistaRapidaObj.rebutanul = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutanul;
                                              this.vistaRapidaObj.totRebutAnul++;
                                              break;
                                          }
                                          default: { 
                                            this.vistaRapidaObj.rebutanul = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.rebutanul;
                                            this.vistaRapidaObj.totRebutAnul++;
                                            break; 
                                          } 
                                      }
                                    }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                                  /** calculo del importe total */
                                  this.vistaRapidaObj.totImportFact = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportFact;
                                  /**calculo del importe por estado de la factura */
                                  for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                    if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciofact){
                                      let situacion = ws[numws - 1].valores[z][t].valor;
                                      switch(situacion.trim()){
                                        case ETIQUETAS.VALORES.FACTURES.pagada:{
                                          this.vistaRapidaObj.factpagat = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factpagat;
                                          this.vistaRapidaObj.totFacPag++;
                                          break;
                                        }
                                        case ETIQUETAS.VALORES.FACTURES.incidencia:
                                        case ETIQUETAS.VALORES.FACTURES.rebutjada:{
                                          this.vistaRapidaObj.factincid = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factincid;
                                          this.vistaRapidaObj.totFacIncid++;
                                          break;
                                        }
                                        case ETIQUETAS.VALORES.FACTURES.pendent:{
                                          this.vistaRapidaObj.factpende = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.factpende;
                                          this.vistaRapidaObj.totFacPend++;
                                          break;
                                        }
                                      }
                                    }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.QUEIXESBYNIF: {
                                  let fechaAño = new Date().setFullYear(new Date().getFullYear() - 1);
                                  for(let m = 0; m < ws[numws - 1].valores[z].length; m++){
                                      if(ws[numws - 1].valores[z][m].numorder === this.vistaRapidaObj.posiciofecha){
                                          let fechaWSForm = this.formatFecha(ws[numws - 1].valores[z][m].valor);
                                          
                                          let fechames = fechaWSForm.substring(0, 3);
                                          let fechadia = fechaWSForm.substring(3, 6);
                                          let fechaanio = fechaWSForm.substring(6, 10);
                                          let fechtot = fechadia + fechames + fechaanio;

                                          let fechaWSDate = new Date(fechtot);
                                          let fechaWS = fechaWSDate.setFullYear(fechaWSDate.getFullYear());
                                          if(fechaWS >= fechaAño){
                                              this.arrayVal.push(ws[numws - 1].valores[z]);
                                          }
                                      }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                                  /** calculo del importe total */
                                  this.vistaRapidaObj.totImportContr = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.totImportContr;
                                  /**calculo del importe por estado del contrato */
                                  for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                    if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posiciocontrac){
                                        this.vistaRapidaObj.contImporNotFac = +ws[numws - 1].valores[z][t].valor + this.vistaRapidaObj.contImporNotFac;
                                    }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.PASEXPEDULTANYWSI: {

                                  for(let t = 0; t < ws[numws - 1].valores[z].length; t++){
                                    if(ws[numws - 1].valores[z][t].numorder === this.vistaRapidaObj.posicioexped){
                                        let situacion = ws[numws - 1].valores[z][t].valor;
                                        switch(situacion.trim()){
                                            case ETIQUETAS.VALORES.EXPEDIENTS.ajud:{
                                                this.vistaRapidaObj.expedAjud = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedAjud;
                                                this.vistaRapidaObj.totExpedAjud++;
                                                break;
                                            }
                                            case ETIQUETAS.VALORES.EXPEDIENTS.trib:{
                                                this.vistaRapidaObj.expedTrib = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedTrib;
                                                this.vistaRapidaObj.totExpedTrib++;
                                                break;
                                            }
                                            case ETIQUETAS.VALORES.EXPEDIENTS.satrans:{
                                                this.vistaRapidaObj.expedSanc = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedSanc;
                                                this.vistaRapidaObj.totExpedSanc++;
                                                break;
                                            }
                                            case ETIQUETAS.VALORES.EXPEDIENTS.altr:{
                                                this.vistaRapidaObj.expedAltr = +ws[numws - 1].valores[z][y].valor + this.vistaRapidaObj.expedAltr;
                                                this.vistaRapidaObj.totExpedAltr++;
                                                break;
                                            }
                                        }
                                    }
                                  }

                                  let valor = ws[numws - 1].valores[z][y].valor;
                                  switch(valor.trim()){
                                      case ETIQUETAS.VALORES.EXPEDIENTS.excucio:
                                      case ETIQUETAS.VALORES.EXPEDIENTS.arxivat:
                                      case ETIQUETAS.VALORES.EXPEDIENTS.tancat:{
                                        this.vistaRapidaObj.expedFinal++;
                                        break;
                                      }
                                      default: {
                                        this.vistaRapidaObj.expedCurso++;
                                        break;
                                      }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.NOTCOMVIGWSI: {
                                  if(ws[numws - 1].valores[z][y].valor.trim() === ETIQUETAS.VALORES.NOTIFIC.n){
                                      this.existNotif = true;
                                      this.vistaRapidaObj.totNotVig++;
                                      this.arrayVal.push(ws[numws - 1].valores[z]);
                                  }else{
                                      this.existComun = true;
                                      this.vistaRapidaObj.totComVig++;
                                      this.arrayValApoyo.push(ws[numws - 1].valores[z]);
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.DADESCONTACTE: {
                                  let valor = ws[numws - 1].valores[z][y].valor;
                                  if(valor === ETIQUETAS.VALORES.CONTACTE.movil){
                                      for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                          if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                              this.vistaRapidaObj.movil = ws[numws - 1].valores[z][d].valor;
                                          }
                                      }
                                  }
                                  if(valor === ETIQUETAS.VALORES.CONTACTE.fax){
                                      for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                          if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                              this.vistaRapidaObj.fax = ws[numws - 1].valores[z][d].valor;
                                          }
                                      }
                                  }
                                  if(valor === ETIQUETAS.VALORES.CONTACTE.email){
                                      for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                          if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                              this.vistaRapidaObj.email = ws[numws - 1].valores[z][d].valor;
                                          }
                                      }
                                  }
                                  if(valor === ETIQUETAS.VALORES.CONTACTE.telefono){
                                      for(let d = 0; d < ws[numws - 1].valores[z].length; d++){
                                          if(ws[numws - 1].valores[z][d].numorder === this.vistaRapidaObj.posicioDescrip){
                                              this.vistaRapidaObj.telefono = ws[numws - 1].valores[z][d].valor;
                                          }
                                      }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB: {
                                  let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
                                  for(let t = 0; t < ws[numws - 1].etiquetas.length; t++){
                                      if(idioma == OPTIONAL_LANG){
                                          this.gestioEtiquTramitsAtres(ws, numws, t, this.vistaRapidaObj.textcarpcat);
                                          this.gestioValoresTramitsAtres(ws, numws, t, z, this.vistaRapidaObj.textcarpcat);
                                      }else{
                                          this.gestioEtiquTramitsAtres(ws, numws, t, this.vistaRapidaObj.textcarpesp);
                                          this.gestioValoresTramitsAtres(ws, numws, t, z, this.vistaRapidaObj.textcarpesp);
                                      }
                                  }
                                  break;
                                }
                                case CODE_WEBSERVICES.VRWSPASHABITADADESWSI: {
                                  let valor = ws[numws - 1].valores[z][y].valor;
                                  if(etiqueta === ETIQUETAS.NOMBRE.individual){
                                      this.vistaRapidaObj.individual = _.cloneDeep(valor);
                                  }
                                  if(etiqueta === ETIQUETAS.NOMBRE.colectivo){
                                      this.vistaRapidaObj.colectivo = _.cloneDeep(valor);
                                  }
                                  break;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
  }

  /**
  * Función para ordenar los objetos de datos esborranys que me vienen del ws ordenados por fecha
  * @param datos array objetos de datos esborranys
  * @param numetiquetas numero de teiquetas que vienen asociados al bobjeto
  */
  public ordenarPorFecha(datos: WebserviceValorDato[][], numetiquetas: number): WebserviceValorDato[][] {

    let formatoFecha = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
    let fechas: string[] = [];

    for (let i = 0; i < datos.length; i++) {
        for (let x = 0; x < numetiquetas; x++) {
            if (datos[i][x] != null && formatoFecha.test(datos[i][x].valor)) {
                fechas.push(datos[i][x].valor);
                break;
            }
        }
    }
    let fechasOrdenadas = this.ordenarFechas(fechas);
    let arrayOrdenado: any[][] = [];
    for (let fecha of fechasOrdenadas) {
        for (let i = 0; i < datos.length; i++) {
            for (let x = 0; x < numetiquetas; x++) {
                if (datos[i][x] != null && formatoFecha.test(datos[i][x].valor)) {
                    if (datos[i][x].valor === fecha) {
                        arrayOrdenado.push(datos[i]);
                        break;
                    }
                }
            }
        }
    }

    return arrayOrdenado;
  }

  /**
  * Función para ordenar el array de fechas que me viene del ws
  * @param fechas listado de valores que nos traemos de los WS
  */
  public ordenarFechas(fechas: string[]): string[] {
      function convertirAFecha(cadenaFecha: string): Date {
          let partes = cadenaFecha.split(" ");
          let fechaPartes = partes[0].split("/");
          let horaPartes = partes[1].split(":");

          // El mes se resta 1 porque en JavaScript los meses van de 0 a 11
          return new Date(Number(fechaPartes[2]), Number(fechaPartes[1]) - 1, Number(fechaPartes[0]), Number(horaPartes[0]), Number(horaPartes[1]), Number(horaPartes[2]));
      }

      return fechas.sort(function(a, b) {
          // Invertir el orden de la comparación para ordenar de manera inversa
          return convertirAFecha(b).getTime() - convertirAFecha(a).getTime();
      });
  }

  /**
  * Función para gestionar tramits y altres serveis quitando etiquetas que correspondan
  * @param ws listado de info traida de los WS
  * @param posws posicion del ws en la lista.
  * @param posetiq posicion de etiqueta en la lista de etiquetas
  * @param etiqueta posicion de etiqueta que vamos a suprimir.
  */
  gestioEtiquTramitsAtres(ws: WebservicesParse[], posws: number, posetiq: number, etiqueta: number){
    if(ws[posws - 1].etiquetas[posetiq].numorder === etiqueta){
        const index = ws[posws - 1].etiquetas.indexOf(ws[posws - 1].etiquetas[posetiq], 0);
        if (index > -1) {
            ws[posws - 1].etiquetas.splice(index, 1);
        }
    }
  }

  /**
  * Función para gestionar tramits y altres serveis quitando los valorese relacionados que correspondan
  * @param ws listado de info traida de los WS
  * @param posws posicion del ws en la lista.
  * @param posetiq posicion de etiqueta en la lista de etiquetas
  * @param posval posicion del valor en la lista de valores
  * @param etiqueta posicion del valor que vamos a suprimir.
  */
  gestioValoresTramitsAtres(ws: WebservicesParse[], posws: number, posetiq: number, posval: number, etiqueta: number){
      if(ws[posws - 1].valores[posval][posetiq].numorder === etiqueta){
          const index = ws[posws - 1].valores[posval].indexOf(ws[posws - 1].valores[posval][posetiq], 0);
          if (index > -1) {
              ws[posws - 1].valores[posval].splice(index, 1);
          }
      }
  }

  /**
  * Solicita los wsdefs de cada setvalue
  * @param item Setvalue
  */
  getWsdef(item: any) {
    let setvalue = new Setvalues();
    let wsdefact = new Array<Wsdefs>();
    setvalue = item;
    for (let i = 0; i < this.wsdefsrol.length; i++) {
      if (setvalue.id === this.wsdefsrol[i].setvalue.id) {
        wsdefact.push(this.wsdefsrol[i]);
      }
    }
    return of(wsdefact);
  }

  /**
  * Asigna a cada setvalue su array de wsdefs
  * @param items Lista de listas de wsdefs de un setvalue
  */
  assignWsdefsToSetvalue(items: any) {
    for (let i = 0; i < items.length; i++) {
      const array = items[i];
      if (array.length > 0) {
        const setvalue_id = array[0].setvalue.id;
        for (let j = 0; j < this.setvalues.length; j++) {
          const setvalue = this.setvalues[j];
          if (setvalue.id == setvalue_id) {
            setvalue.wsdefs = _.cloneDeep(array);
            setvalue.wsdefs = _.orderBy(setvalue.wsdefs, 'numorder');
            break;
          }
        }
      }
    }
  }

  /***************************************************************************/
  /***                              MOSTRAR MENU                           ***/
  /***************************************************************************/

  /**
  * Gestiona los datos de las pestañas del menú orizontal
  * @param dato nos dice si estamos en pasarela, empresas o proveedores
  */
  public mostrarMenu(dato: string) {

    this.translateService.get(['MENU']).subscribe((res: string[]) => {

      this.items = [
        {
          label: this.translateService.instant('MENU.seu'),
          command: e => this.redirContingut()
        },
        { separator: true },
        {
          label: this.translateService.instant('MENU.conf_avisos'),
          //command: e => this.confiAvisos(dato)
        },
        { separator: true },
        {
          label: this.translateService.instant('MENU.perfil_usuario'),
          //command: e => this.confiPerfil(dato)
        },
      ];
    });
  }

  /**
  * @description
  * Redirige a una web perteneciente al ayunt reus del menú horizontal
  */
  public redirContingut() {
    window.open(LINKS_EXTERNAL.REUS_SEU);
  }

  /**
  * @description
  * Función que nos redirige al cuadro de dialogo de los avisos (menú horizontal)
  */
  public confiAvisos() {
    let tipocarpeta = this.carpeta;;
    const dialogRef = this.dialog.open(DialogsAvisosComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { tipocarpeta }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorCargaWS(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }


  /**
  * @description
  * Función que nos redirige al cuadro de dialogo del perfil del usuario (menú horizontal)
  * @param dato nos dice si estamos en pasarela, empresas o proveedores
  */
  public confiPerfil() {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";

    let tipocarpeta = this.carpeta;
    let dboid = localStorage.getItem(STORAGE.DBOID);

    const dialogRef = this.dialog.open(DialogsPerfilComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { tipocarpeta, dboid}
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if(result){
        this.refrescoHeader = true;
        this.refrescar(localStorage.getItem(STORAGE.DBOID));
      }
    });
  }

  /**
  * @description
  * Función que nos redirige al cuadro de dialogo de busqueda externa
  */
  public buscarExterna() {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";

    let tipocarpeta = this.carpeta;
    let dboid = localStorage.getItem(STORAGE.DBOID);

    const dialogRef = this.dialog.open(DialogsBuscadorExternaComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { tipocarpeta, dboid}
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      if(result != "" && result != undefined){
        this.tramitsbusqueda = _.cloneDeep(result);
        this.cargarTramitsYCarpeta();
        console.log(result);
      }
    });
  }

  /**
  * @description
  * Nos da un valor sacado de juntar variables temporales (dia, hora, minuto...) para poder crear una sesión única
  */
  public obtenersesion(): string{
    return this.datePipe.transform(new Date(), 'yyyyMMddHHmmssSSS') ?? '';
  }

  /**
  * @description
  * Función que nos permite entrar a los distintos servicios de la OVT
  * @param code codigo de cada departamento disponible de la OVT
  */
  public accederGTTGeneral(code : string, dato: string) : string {

    let stringidioma: string;
    if(this.idioma === DEFAULT_LANG){
      stringidioma = _.cloneDeep("ct");
    }else{
      stringidioma = _.cloneDeep("ca");
    }

    let servicio = PARAMS_OVT.SERVICIO;
    let suborganismo = PARAMS_OVT.SUBORGANISMO;
    let clave = PARAMS_OVT.CLAVE;

    let urlretorno = this.gtturl + "api/xml/";
    let stringfecha = this.datePipe.transform(new Date(), 'yyyyMMdd');
    let sesion = this.obtenersesion();

    let concatenacion = servicio + suborganismo + this.nif + sesion + stringfecha + clave;
    let firmaSha512 = CryptoJS.SHA512(concatenacion).toString(CryptoJS.enc.Hex);

    let cadena = "";
    let url = this.gtturl + 'api/xml/?xml=';
    cadena += '<?xml version="1.0" encoding="UTF-8"?>';
    cadena += '<g00001_e>';
    cadena += '<nombre_servicio>' + servicio + '</nombre_servicio>';
    cadena += '<suborganismo>' + suborganismo + '</suborganismo>';
    cadena += '<idcliente>' + this.nif + '</idcliente>';
    cadena += '<firma>' + firmaSha512 + '</firma>';
    cadena += '<sesion>' + sesion + '</sesion>';
    cadena += '<fecha>' + stringfecha + '</fecha>';
    cadena += '<idioma>' + stringidioma + '</idioma>';
    cadena += '<url_retorno>' + urlretorno + "</url_retorno>";
    cadena += '<nifrepresentante>' + "" + '</nifrepresentante>';
    cadena += '<nombrerepresentante>' + "" + '</nombrerepresentante>';
    cadena += '<nombre_usuario>' + "" + '</nombre_usuario>';
    if(code != ""){
      cadena += '<redireccion>' + code + '</redireccion>';
    }
    if(dato != ""){
      cadena += '<datoRedireccion>' + dato + '</datoRedireccion>';
    }
    cadena += '</g00001_e>';
    cadena = encodeURIComponent(cadena);

    return url + cadena;
  }

  /**
  * @description
  * Función que nos redirige directamente a otra pestaña de la aplicación
  * @param code codigo de cada departamento disponible de la OVT
  */
  public accederGTT(code : Wsdefs, dato : string) {
    let redireccion = "";
    if(code.setvalue.code == "WS-OVT"){
      redireccion = this.accederGTTGeneral(code.url, dato);
    }else{
      redireccion = code.url;
    }
    window.open(redireccion, '_blank');
  }

  /**
  * @description
  * Función que nos redirige al cuadro de dialogo representacion OAC del usuario
  */
  public accesoDialogOAC(){
    let carpeta: string = "";
    switch(this.rol){
      case EXTERNAL_ROL.PAGES.ciudadano: {
        carpeta = "1";
        break;
      }
      case EXTERNAL_ROL.PAGES.empresa: {
        carpeta = "2";
        break;
      }
      case EXTERNAL_ROL.PAGES.proveedor: {
        carpeta = "3";
        break;
      }
    }
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(DialogsRepresentantAocComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { representant : this.allrepresOAC , llamada: 2, carpeta: carpeta, dni: this.tercer[0].nif }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result != undefined){
        this.refrescarAOC(result);
      }
    });
  }


  /**
  * @description
  * Gestión de los Webservices que están desactivados
  * @param dato WS que nos traemos del cliente
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWS(dato: Wsdefs, posicionA: number, posicionB: number) : Observable<any> {

    this.gestionLabelStyle();
    if(this.vista_rapida.quickview == 1){
      const el = document.getElementById("vistaRapida");
      if (el) {
        el.classList.remove('active');
      }
    }

    if(posicionA != null && posicionB != null){
      const el = document.getElementById("labelWS" + posicionA + posicionB);
      if (el) {
        el.classList.add('active');
      }
    }

    this.vistaRapida = false;
    this.isTramite = false;
    let chivato = false;
    //this.webservicesParseDef = new Array<WebservicesParse>();

    for(let i = 0; i < this.webservicesParse.length; i++){
      if(this.webservicesParse[i].code.trim() == dato.code.trim()){
          chivato = true;
      }
    }

    if(chivato == false){
        return this.recogerWSObservable(dato);
    }else{
        return of(this.recogerWSEnable(dato, posicionA, posicionB));
    }
  }

  /**
  * @description
  * Hacemos la llamada al servidor de los Webservices que están desactivados
  * @param dato WS que nos traemos del cliente
  */
  public recogerWSObservable(dato: Wsdefs) : Observable<any> {
    /*Rellenamos el objeto webservice para pasarselo al servidor*/
    let webser = this.asignacionAtribObject(dato);
    return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map(data => {

        let webservice = new Array<WebservicesParse>();
        webservice = _.cloneDeep(data);

        /**Formateamos las URLS para que esten disponibles en una segunda llamada (no carga el WS)*/
        this.formatTipoWS(webservice);
        this.webservicesParse.push(webservice[0]);

        this.webservicesParseDef = data;
        this.formatTipoWS(this.webservicesParseDef);
        this.asignacionFormatoValor(this.webservicesParseDef[0]);

        if(this.webservicesParseDef[0].valores != null){
            this.filtroFechaNumero(this.webservicesParseDef[0]);
        }

        /*CalculoImportes para gestionar tramits y altres serveis quitando etiquetas y valores cuando corresponda*/
        switch(this.webservicesParseDef[0].code){
          case CODE_WEBSERVICES.WSAVISOSHABITANTEPOB:{
            this.calculoImportes(this.webservicesParseDef, this.webservicesParseDef[0].code, 0, 0, 1, ETIQUETAS.NOMBRE.textcarpcat);
            this.calculoImportes(this.webservicesParseDef, this.webservicesParseDef[0].code, 0, 0, 1, ETIQUETAS.NOMBRE.textcarpesp);
            break;
          }
        }

        this.gestionIconos(this.webservicesParseDef[0]);
        this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
        return this.webservicesParseDef;
    }, (error: any)=> {
        this.textContacte = true;
        console.log("Error: " + error);
    }));
  }

  /**
  * @description
  * Gestión de los Webservices que están activados
  * @param dato WS que nos traemos del cliente
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWSEnable(dato: Wsdefs, posicionA: number, posicionB: number): Observable<any> {

    this.gestionLabelStyle();
    if (this.vista_rapida.quickview == 1) {
      const el = document.getElementById("vistaRapida");
      if (el) {
        el.classList.remove('active');
      }

      if (posicionA != null && posicionB != null) {
        const el2 = document.getElementById("labelWS" + posicionA + posicionB);
        if (el2) {
          el2.classList.add('active');
        }
      }

      this.vistaRapida = false;
      this.isTramite = false;
      this.webservicesParseDef = new Array<WebservicesParse>();
    }

    if (this.wsenabledrefresh) {
      const webser = this.asignacionAtribObject(dato);

      return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map((data: any) => {

          let ws: WebservicesParse[] = _.cloneDeep(data);

          if (this.webservicesParse != null) {
            for (let i = 0; i < this.webservicesParse.length; i++) {
              if (this.webservicesParse[i].code === dato.code) {
                this.webservicesParseDef.push(ws[0]);
              }
            }
          }

          this.ordenarVistaWS();
          this.asignacionFormatoValor(this.webservicesParseDef[0]);
          this.gestionIconos(this.webservicesParseDef[0]);

          this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);
          this.wsenabledrefresh = false;

          return this.webserviceVista;
        })
      );
    }

    let chivato = false;

    if (this.webservicesParse != null) {
      for (let i = 0; i < this.webservicesParse.length; i++) {
        if (this.webservicesParse[i].code === dato.code) {
          this.webservicesParseDef.push(this.webservicesParse[i]);
          chivato = true;
        }
      }
    }

    if (!chivato) {
      const webser = this.asignacionAtribObject(dato);

      return this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).pipe(map((data: any) => {

          let ws: WebservicesParse[] = _.cloneDeep(data);

          this.webservicesParseDef.push(ws[0]);

          this.ordenarVistaWS();
          this.asignacionFormatoValor(this.webservicesParseDef[0]);
          this.gestionIconos(this.webservicesParseDef[0]);

          this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);

          return this.webserviceVista;
        })
      );
    }

    this.ordenarVistaWS();
    this.asignacionFormatoValor(this.webservicesParseDef[0]);
    this.gestionIconos(this.webservicesParseDef[0]);

    this.webserviceVista = _.cloneDeep(this.webservicesParseDef[0]);

    return of(this.webserviceVista);
  }

  /**
  * @description
  * Recoge el icono seleccionado de cada limk y lo introduce en las vistas
  * @param webservicesParse datos del wsparse correspondiente
  */
  public gestionIconos(webservicesParse: WebservicesParse){
    for (let x = 0; x < webservicesParse.etiquetas.length; x++) {
      for (let y = 0; y < this.fieldLinks.length; y++) {
        if(this.fieldLinks[y].xmlfields.length > 0){
          for (let z = 0; z < this.fieldLinks[y].xmlfields.length; z++) {
            if(webservicesParse.etiquetas[x].id == this.fieldLinks[y].xmlfields[z].id){
              webservicesParse.etiquetas[x].fieldtypeId.unit = _.cloneDeep(this.fieldLinks[y].icon);
            }
          }
        }
      }
    }
  }

  /**
  * @description
  * Etiquetas y valores se desordenan despues del refresh; así que las volvemos a ordenar
  */
  public ordenarVistaWS(){
    if (this.webservicesParseDef[0].etiquetas != null) {
      if (this.webservicesParseDef[0].etiquetas.length > 0 && this.webservicesParseDef[0].valores != null) {
        this.webservicesParseDef[0].etiquetas = _.orderBy(this.webservicesParseDef[0].etiquetas, 'numorder');
        for (let i = 0; i < this.webservicesParseDef[0].valores.length; i++) {
            this.webservicesParseDef[0].valores[i] = _.orderBy(this.webservicesParseDef[0].valores[i], 'numorder');
        }
        if (this.webservicesParseDef[0].valores != null) {
          this.filtroFechaNumero(this.webservicesParseDef[0]);
        }
      }
    }
  }

  /**
  * @description
  * Desactiva el estilo activo de todos las pestañas de los web_services
  */
  public gestionLabelStyle(){
    var array = document.getElementsByClassName("text__sm");
    for(var e = 0; e < array.length; e++) {
        var elemento = array[e];
        if(elemento.className === "text__sm clickable active"){
            elemento.className = "text__sm clickable";
        }
    }
  }

  /**
  * @description
  * Activa el estilo activo de todos vista rapida; desaciva los demás y oculta los WS
  * seleccionados mostrando la vista rápida
  */
  public vistaRapidaEvent(){

    /**Al pulsar vista rápida en el menú en dispositivos móviles, este se plega**/
    let menuAbrir = document.getElementById("collapseOne");
    let menuCerrar = document.getElementById("menumovilCerrar");

    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
          menuAbrir.style.display = "none";
          menuCerrar.style.display = "block";
          window.scrollTo(0, 0);
      }else{
          menuAbrir.style.display = "";
          menuCerrar.style.display = "";
          window.scrollTo(0, 0);
      }
    }

    this.vistaRapida = true;
    this.isTramite = false;
    this.gestionLabelStyle();
    if(this.vista_rapida.quickview == 1){
      const el = document.getElementById("vistaRapida");
      if (el) {
        el.classList.add('active');
      }
    }
  }

  /**
  * @description
  * Formatea el tipo de dato que se visualizan en la tablas de la interfaz (sobretodo enlaces)
  * @param item lista de WS que nos traemos del servidor
  */
  public formatTipoWS(item: WebservicesParse[]) {
      let numero: number = 0;
      for (let i = 0; i < item.length; i++) {
        numero = 0;

        item[i].etiquetas = _.orderBy(item[i].etiquetas, 'numorder');
        if(item[i].valores != null){
          for(let x = 0; x < item[i].valores.length; x++){
              item[i].valores[x] = _.orderBy(item[i].valores[x], 'numorder');
          }
        }

        if (item[i].etiquetas != null) {
            for (let x = 0; x < item[i].etiquetas.length; x++) {
              numero++;
              if(item[i].etiquetas[x].fieldtypeId.format === 1 || item[i].etiquetas[x].fieldtypeId.format === 2){
                this.valoresLinks(item, i, numero);
              }

              /*Gestiona atributo visibitily de permisos a etiquetas para visionarla o on en interna y externa*/
              for(let c = 0; c < item[i].permisos.length; c++){
                if(item[i].etiquetas[x].id === item[i].permisos[c].permissionableId){
                  item[i].etiquetas[x].visibility = _.cloneDeep(item[i].permisos[c].visibility);
                  
                  if(item[i].valores != null){
                    for(let d = 0; d < item[i].valores.length; d++){
                      for(let e = 0; e < item[i].valores[d].length; e++){
                        if(item[i].etiquetas[x].numorder ===  item[i].valores[d][e].numorder){
                          if(item[i].etiquetas[x].visibility === 0){
                            item[i].valores[d][e].visibility = 0;
                          }else{
                            item[i].valores[d][e].visibility = 1;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        }
      }
    return item;
  }

  /**
  * @description
  * funcion que construye la url de los links de la s tablas de los WS
  * @param valores array de los datos del ws seleccionado
  * @param posval posicion del WS en la lista de WS almacenados en memoria
  * @param posnum posicion de la etiqueta a la que hace referencia el link
  */
  private valoresLinks(valores: WebservicesParse[], posval: number, posnum: number){
    let url: string = "";
    let codeUrl: string = "";
    let urlCompleta: string = "";
    let idxmldef: number | null = null;

    for(let k = 0; k < this.xmldefs.length; k++){
        if(this.xmldefs[k].code === valores[posval].codXmldef){
            idxmldef = _.cloneDeep(this.xmldefs[k].id);
        }
    }
    
    for(let p = 0; p < this.fieldLinks.length; p++){
      if(this.fieldLinks[p].xmlfields.length > 0){
          for(let c = 0; c < this.fieldLinks[p].xmlfields.length; c++){
            if(this.fieldLinks[p].xmlfields[c].xmldefId === idxmldef){
              if(this.fieldLinks[p].xmlfields[c].code === valores[posval].etiquetas[posnum - 1].code){
                  url = _.cloneDeep(this.fieldLinks[p].url);
              }
            }
          }
      }
    }
    
    if(url.includes('{{FI4_IDNUMBER}}')){
        url = url.replace('{{FI4_IDNUMBER}}', this.nif);
    }
    if(url.includes('{{FI4TOKEN}}')){
        url = url.replace('{{FI4TOKEN}}', this.validToken.token);
    }
    if(url.includes('{{IDIOMA}}')){
      url = url.replace('{{IDIOMA}}', this.idioma);
    }
    if (valores[posval].valores != null) {
        for (let y = 0; y < valores[posval].valores.length; y++) {
            codeUrl = valores[posval].valores[y][posnum - 1].valor;
            urlCompleta = url.replace('{{SELF.VALUE}}', codeUrl);
            valores[posval].valores[y][posnum - 1].valor = urlCompleta;
        }
    }
  }


  public addVisibility(item: WebservicesParse[]) {
    for(let x = 0; x < item.length; x++){
      for(let b = 0; b < item[x].etiquetas.length; b++){
        for(let c = 0; c < item[x].permisos.length; c++){
          let auxval = 0;
          if(item[x].etiquetas[b].id === item[x].permisos[c].permissionableId){
            item[x].etiquetas[b].visibility = _.cloneDeep(item[x].permisos[c].visibility);
          }
          if(item[x].valores != null){
            auxval = item[x].valores.length;
            for(let d = 0; d < item[x].valores[auxval- 1].length; d++){
              let auxnumVal = 0;
              if(item[x].valores[d] != null){
                auxnumVal = item[x].valores[d].length;
                console.log(auxnumVal);
                for(let e = 0; e < item[x].valores[d].length; e++){
                  if(item[x].etiquetas[b].numorder ===  item[x].valores[auxval- 1][auxnumVal -1].numorder){
                    //item[x].valores[auxval- 1][auxnumVal - 1].visibility = _.cloneDeep(item[x].etiquetas[b].visibility);
                    //console.log(item[x].valores[auxval- 1][auxnumVal - 1].visibility);
                  }
                }
              } 
            }
          }
        }
      }
    }
  }


  /**
  * @description
  * Salir a la página de inicio
  */
  public salir(){
    switch(this.rol){
      case EXTERNAL_ROL.PAGES.ciudadano: {
        this.router.navigate(['/external/passarela/acces']);
        break;
      }
      case EXTERNAL_ROL.PAGES.empresa: {
        this.router.navigate(['/external/empreses/acces']);
        break;
      }
      case EXTERNAL_ROL.PAGES.proveedor: {
        this.router.navigate(['/external/proveidors/acces']);
        break;
      }
    }
    
  }

  /**
  * @description
  * Refrescar la pagina tanto con boton refresco como con selector de terceros y representantes
  * @param dato dato del selector, si es pulsando boton refresco el valor es null
  */
  public refrescar(dato: any){
    
    if(this.allrepresOAC != null){
      this.refrescarAOC(dato);
    }else{
      this.bannerRefre = false;
      this.AOCRefresca = false;
      let rol = this.rol;

      if(this.idRepresentante === null){
        if(dato != null){
          localStorage.setItem(STORAGE.DBOID, dato);
        }else{
          localStorage.setItem(STORAGE.DBOID, this.persons.dboid);
        }
      }

      let idcomany = null;
      if(this.idRepresentante != null){
        if(dato != null){
          idcomany = dato;
        }else{
          idcomany = this.idRepresentante;
        }
      }
      
      let objetoexternal = new DataExternal();
      objetoexternal.representantAOC?.identificador;
      objetoexternal.dboid = _.cloneDeep(localStorage.getItem(STORAGE.DBOID) ?? '');
      objetoexternal.tercer = _.cloneDeep(this.tercerApoyo);
      objetoexternal.representant = _.cloneDeep(idcomany);
      objetoexternal.representants = _.cloneDeep(this.represApoyo);
      objetoexternal.representantAOC = null;
      objetoexternal.representantsAOC = [];
      this.wsdefsrol = new Array<Wsdefs>();

      this.initView(rol, objetoexternal).subscribe(res => {
        console.log(res);
      }, error => {
        this.router.navigate(['/external/passarela/acces']);
        console.log("Error: " + error);
      });
    }
  }

  /**
  * @description
  * Refrescar la pagina cuando estamos manejando datos de representa AOC
  * @param dato si es pulsando boton AOC el valor es AuxiliarAOC
  */
  public refrescarAOC(dato: AuxiliarAOC){
    this.bannerRefre = false;
    this.AOCRefresca = true;
    let rol = this.rol;
    
    let objetoexternal = new DataExternal();
    objetoexternal.dboid = _.cloneDeep(localStorage.getItem(STORAGE.DBOID) ?? '');
    objetoexternal.tercer = _.cloneDeep(this.tercerApoyo);
    objetoexternal.representant = null;
    objetoexternal.representants = [];

    if (!objetoexternal.representantAOC) {
      objetoexternal.representantAOC = new AuxiliarAOC();
    }

    if(dato != null){

      objetoexternal.representantAOC.identificador = _.cloneDeep(dato.identificador);
      objetoexternal.representantAOC.check = _.cloneDeep(dato.check);
      if(dato.check == 1 && dato.llamada == 2){
        objetoexternal.representantAOC.dboid = _.cloneDeep(this.tercer[0].dboid);
        objetoexternal.representantAOC.carpeta = _.cloneDeep(dato.carpeta);
      }if(dato.check == 2 && dato.llamada == 2){
        objetoexternal.representantAOC.dboid = _.cloneDeep(dato.dboid);
        objetoexternal.representantAOC.carpeta = _.cloneDeep(dato.carpeta);
      }else{
        objetoexternal.representantAOC.dboid = _.cloneDeep(localStorage.getItem(STORAGE.DBOID) ?? '');
      }
    }else{
      this.llamadaAux = 3;
    }

    objetoexternal.representantsAOC = _.cloneDeep(this.represOACApoyo);
    if(dato != null && dato.representantsAOC != null && dato.representantsAOC.length > 0){
      objetoexternal.representantsAOC = _.cloneDeep(dato.representantsAOC);
    }
    this.wsdefsrol = new Array<Wsdefs>();

    this.initView(rol, objetoexternal).subscribe(res => {
      console.log(res);
    }, error => {
      this.router.navigate(['/external/passarela/acces']);
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Filtro para la busqueda en la tabla de los ws
  * @param text texto que introducimos en la caja de texto
  */
  public filterGlobal(text: string){

    text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";

    if (text == "") {
      this.webserviceVista.valores = _.cloneDeep(this.webservicesParseDef[0].valores);
      return;
    }

    text = Utils.replaceAccentedVowels(text);

    let originalWS = _.cloneDeep(this.webservicesParseDef[0]);
    this.webserviceVista.valores = [];

    for (let i = 0; i < originalWS.valores.length; i++) {
      let match = false;
      let ws = originalWS.valores[i];

      for(let x = 0; x < ws.length; x++) {
        if(ws[x].formato == 0){
          let registro = _.deburr(_.trim(ws[x].valor).toLocaleLowerCase());
          if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
              match = true;
              break;
          }
        }
      }

      if(match) {
        this.webserviceVista.valores.push(ws);
      }
    }
  }

  /**
  * @description
  * Filtro para la busqueda de una categoría o wsdef en el menu selector
  * @param text texto que introducimos en la caja de texto
  */
  public filterMenu(text: string){

    text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";
    text = _.deburr(_.trim(text));

    if (text == "") {
        this.setvalues = _.cloneDeep(this.setvaluesBusca);
        return;
    }

    let originalWS = _.cloneDeep(this.setvaluesBusca);

    this.setvalues = new Array<Setvalues>();
    let setvaluesaux = new Array<Setvalues>();

    let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;

    for (let i = 0; i < originalWS.length; i++) {
        let registro : String = "";
        let match = false;
        let setVal = originalWS[i];

        let setaux = new Setvalues();
        setaux = _.cloneDeep(setVal);
        setaux.wsdefs = new Array<Wsdefs>();

        for(let x = 0; x < setVal.wsdefs.length; x++) {
            if(idioma == "ca"){
                registro = _.deburr(_.trim(setVal.wsdefs[x].cat).toLocaleLowerCase());
            }else{
                registro = _.deburr(_.trim(setVal.wsdefs[x].esp).toLocaleLowerCase());
            }
            if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
                setaux.wsdefs.push(setVal.wsdefs[x]);
            }
        }

        if(setaux.wsdefs.length > 0){
            setvaluesaux.push(setaux);
        }
    }

    for (let i = 0; i < originalWS.length; i++) {
        let registro : string = "";
        if(idioma == "ca"){
            registro = _.deburr(_.trim(originalWS[i].cat).toLocaleLowerCase());
        }else{
            registro = _.deburr(_.trim(originalWS[i].esp).toLocaleLowerCase());
        }
        if (text != "" && _.includes(registro, text.toLocaleLowerCase())) {
            if(idioma == "ca"){
                if(_.deburr(_.trim(originalWS[i].cat).toLocaleLowerCase()) == registro){
                    for (let p = 0; p < originalWS.length; p++) {
                        if(_.deburr(_.trim(originalWS[p].cat).toLocaleLowerCase()) == registro){
                            let auxiliar : boolean = false;
                            for(let b = 0; b < setvaluesaux.length; b++){
                                if(setvaluesaux[b].id === originalWS[i].id){
                                    auxiliar = true;
                                }
                            }
                            if(auxiliar == false){
                                setvaluesaux.push(originalWS[p]);
                            }
                            //setvaluesaux.push(originalWS[p]);
                        }
                    }
                }
            }else{
                if(_.deburr(_.trim(originalWS[i].esp).toLocaleLowerCase()) == registro){
                    for (let p = 0; p < originalWS.length; p++) {
                        if(_.deburr(_.trim(originalWS[p].esp).toLocaleLowerCase()) == registro){
                            let auxiliar : boolean = false;
                            for(let b = 0; b < setvaluesaux.length; b++){
                                if(setvaluesaux[b].id === originalWS[i].id){
                                    auxiliar = true;
                                }
                            }
                            if(auxiliar == false){
                                setvaluesaux.push(originalWS[p]);
                            }
                            //setvaluesaux.push(originalWS[p]);
                        }
                    }
                }
            }
        }
    }

    var lookupObject: { [key: string]: Setvalues } = {};
    for(var i in setvaluesaux) {
        lookupObject[setvaluesaux[i].id] = setvaluesaux[i];
     }

    for(i in lookupObject) {
        this.setvalues.push(lookupObject[i]);
    }

    this.setvalues = _.orderBy(this.setvalues, 'numorder');
  }

  /**
  * @description
  * Dias que han pasado desde la ultima vez que el usurio abrio sesión
  */
  public diasSession(){
    let fechaF: any = new Date().getTime();
    let difM = fechaF - this.dateSesion // diferencia en milisegundos
    let difD = difM / (1000 * 60 * 60 * 24) // diferencia en dias
    this.diasSessionLabel = Math.trunc(difD);
  }

  /**
  * @description
  * Formato de los datos tipo fecha
  * @param tipus fecha
  */
  public formatFecha(tipus: string): string {
    if (tipus != null) {
      let cadena = tipus.indexOf('+');
      let fechFortat = tipus.substring(0, cadena);
      let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy');
      return fecha ?? '';
    }else{
      return tipus;
    }
  }

  /**
  * @description
  * Formato de los datos tipo fecha y tipo número
  * @param webservice Webservices que queremos formatear
  */
  public filtroFechaNumero(webservice : WebservicesParse) {
    for(let i = 0; i < webservice.valores.length; i++){
        for(let x = 0; x < webservice.etiquetas.length; x++){
            if (webservice.valores[i][x].valor != null) {
                if(webservice.etiquetas[x].fieldtypeId.typefld === 1){
                    let valor : string = webservice.valores[i][x].valor.replace('€', '').trim();
                    let decimal: number = +valor;
                    let decimalParse = decimal.toFixed(2);
                    webservice.valores[i][x].valor = decimalParse;
                }
                if(webservice.etiquetas[x].fieldtypeId.typefld === 2){
                    let cadena = webservice.valores[i][x].valor.indexOf('+');
                    if(cadena != -1){
                        let fechFortat = webservice.valores[i][x].valor.substring(0, cadena);
                        let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy');
                        webservice.valores[i][x].valor = fecha;
                    }else{
                      let guion = /\-/gi;
                      let fecha = webservice.valores[i][x].valor.replace(guion, '/');
                      webservice.valores[i][x].valor = fecha;
                    }
                }
                if(webservice.etiquetas[x].fieldtypeId.typefld === 3){
                  let cadena = webservice.valores[i][x].valor.indexOf('+');
                  if(cadena != -1){
                      let fechFortat = webservice.valores[i][x].valor.substring(0, cadena);
                      let fecha = this.datePipe.transform(fechFortat, 'dd/MM/yyyy h:mm a');
                      webservice.valores[i][x].valor = fecha;
                  }else{
                    let guion = /\-/gi;
                    let fecha = webservice.valores[i][x].valor.replace(guion, '/');
                    webservice.valores[i][x].valor = fecha;
                  }
                }
                if(webservice.etiquetas[x].fieldtypeId.code === TIPO_DATO.FI4IMPORT){
                  if(this.idioma === DEFAULT_LANG){
                      webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatout.replace('%s', webservice.valores[i][x].valor));
                  }else{
                      webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatoutes.replace('%s', webservice.valores[i][x].valor));
                  }
                }
                if(webservice.etiquetas[x].fieldtypeId.code === TIPO_DATO.FI4PERCENT){
                  if(this.idioma === DEFAULT_LANG){
                      webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatout.replace('%s', webservice.valores[i][x].valor));
                  }else{
                      webservice.valores[i][x].valor = _.cloneDeep( webservice.etiquetas[x].fieldtypeId.formatoutes.replace('%s', webservice.valores[i][x].valor));
                  }
                }
            }else{
                webservice.valores[i][x].valor;
            }
        }
    }
  }

  /**
  * @description
  * Ordenación de las columnas de las tablas de los ws
  * @param text code de la etiqueta para identificar la columna que hemos pulsado a ordenar
  * @param numero botón al que pulsamos (1 - orden ascendente; 2 - orden descendente)
  */
  public ordenarColumnas(text: any, numero: number){

    let numOrd : number | null = null;
    let arrayDatos = new  Array<WebserviceValorDato>();
    let arrayValores = new Array<Array<WebserviceValorDato>>();
    let esValorString = true;

    for(let i = 0; i < this.webserviceVista.etiquetas.length; i++){
        if(this.webserviceVista.etiquetas[i].code === text){
          numOrd = this.webserviceVista.etiquetas[i].numorder;
        }
    }

    /*Alteramos la vaiable esValorString dependiendo si los valoes son numéricos o no.
      conque haya uno solo que no sea numérico, los trataremos como strings */
    for(let i = 0; i < this.webserviceVista.valores.length; i++){
      for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
        const item = this.webserviceVista.valores[i][x];
        if (item?.numorder == numOrd) {
          const valor = String(item.valor);
          if (!this.isNumeric(valor)) {
            esValorString = false;
          }
        }
      }
    }

    /*Añadimos los datos a un Array para posteriormente ordenarlos*/
    for(let i = 0; i < this.webserviceVista.valores.length; i++){
        for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
          if(this.webserviceVista.valores[i][x].numorder == numOrd){
            if(esValorString){
              this.webserviceVista.valores[i][x].valor = +this.webserviceVista.valores[i][x].valor;
            }
            arrayDatos.push(this.webserviceVista.valores[i][x]);
          }
        }
    }

    /*Ordenación de manera ascendente*/
    arrayDatos =  _.orderBy(arrayDatos, 'valor');

    /*Al pulsar el boton de nuevo; la ordenación es descendente*/
    if(numero == 2){
      this.butonOrderColUp = true;
      this.butonOrderColDown = false;
      let arrayaux = Array<WebserviceValorDato>();
      arrayaux = arrayDatos;
      arrayDatos = Array<WebserviceValorDato>();
      for(let i = arrayaux.length - 1; i >= 0; i--){
        arrayDatos.push(arrayaux[i]);
      }
    }else{
      this.butonOrderColUp = false;
      this.butonOrderColDown = true;
    }

    /*Volvemos a componer el objeto webservicesParseDef con la ordenación ya realizada*/
    for(let i = 0; i < arrayDatos.length; i++){
      for(let z = 0; z < this.webserviceVista.valores.length; z++){
        for(let x = 0; x < this.webserviceVista.etiquetas.length; x++){
          if(arrayDatos[i] == this.webserviceVista.valores[z][x]){
            arrayValores.push(this.webserviceVista.valores[z]);
          }
        }
      }
    }

    this.webserviceVista.valores = _.cloneDeep(arrayValores);
  }

  /**
  * @description
  * Añadimos al objeto WebservicesParse un atributo que nos dirá el formato con el cual irán los distintos valores
  * @param webservice entidad ws WebservicesParse
  */
  public asignacionFormatoValor (webservice : WebservicesParse) {
    if(webservice != null && webservice.valores != null){
        for(let i = 0; i < webservice.valores.length; i++){
            for(let x = 0; x < webservice.etiquetas.length; x++){
                webservice.valores[i][x].formato = webservice.etiquetas[x].fieldtypeId.format;
            }
        }
    }
  }

  /**
  * @description
  * Asignamos valores al objeto Webservice que utilizaremos para hacer las llamadas de los WS
  * @param dato WS al cual vamos a hacer la petición
  */
  public asignacionAtribObject(dato: Wsdefs):Webservice{
    let ws = new Webservice();
    
    ws.userId = "";
    ws.tokenacces = "";
    ws.nifcif = this.nif;
    ws.dboid = localStorage.getItem(STORAGE.DBOID) ?? "";
    ws.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    ws.codEmpresa = PARAMETRES.COD_EMPRESA;
    ws.token = this.webservice.token;
    ws.wsdefs[0] = dato;
    ws.permisos = this.permissions;
    ws.rol = this.rol;
    return ws;
  }

  /**
  * @description
  * Asignamos valores al objeto Webservice que utilizaremos para hacer las llamadas de los WS
  * @param dato array de WS al cual vamos a hacer la petición
  */
  public asignacionAtribArrayObject(dato: Wsdefs[]):Webservice{
    let ws = new Webservice();
    
    ws.tokenacces = "";
    ws.userId = "";
    ws.nifcif = this.nif.toLocaleUpperCase();
    ws.dboid = localStorage.getItem(STORAGE.DBOID) ?? "";
    ws.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    ws.codEmpresa = PARAMETRES.COD_EMPRESA;
    ws.token = this.webservice.token;
    ws.wsdefs = dato;
    ws.permisos = this.permissions;
    ws.rol = this.rol;
    return ws;
  }

  /**
  * @description
  * Nos dice si existe un WS con el codigo pasado por parametro
  * @param code code del WS.
  */
  public buscarObjetoWS(code : string):Boolean{
    let auxiliar = true;
    //wsvistaprevia es la lista de WS filtrados por rol
    for(let i = 0; i < this.wsvistaprevia.length; i++){
        if(this.wsvistaprevia[i].code == code){
            auxiliar = false;
            return auxiliar;
        }
    }
    return auxiliar;
  }


  /**
  * @description
  * Nos devuelve los el array de valores de las queixas para meterlos en el carrusel
  */
  public valoresAvis(): any {
    return this.allAvisUser != null && this.allAvisUser.length > 0 ? this.allAvisUser : null;
  }

  /**
  * @description
  * hacomos una llamada al server para modificar el avis (ponerlo en modo leido)
  * @param avis avis seleccionado
  */
  public modificarAvis(avis: Avis){
    this.numavis = avis.id;
    if(avis.avRead === 0){
      this.avisService.postAvRead(avis).subscribe((data: Avis) => {
        let avisomod = new Avis();
          avisomod = _.cloneDeep(data);
          for(let i = 0; i < this.allAvisUser.length;  i++){
            if(this.allAvisUser[i].id === avisomod.id){
              this.allAvisUser[i] = _.cloneDeep(avisomod);
            }
          }
          for(let i = 0; i < this.allAvisEnable.length;  i++){
            if(this.allAvisEnable[i].id === avisomod.id){
              this.allAvisEnable.splice(i,1);
            }
          }
      }, (error: any) => {
        console.log("Error: " + error);
      });
    }
  }

  /**
  * @description
  * Nos devuelve los el array de valores de las notif/comic para meterlos en el carrusel
  */
  public valoresNotificaciones(): any {
    return this.webNotific.valores != null && this.webNotific.valores.length > 0 ? this.webNotific.valores : null;
  }
  public valoresComunicaciones(): any {
    return this.webComunic.valores != null && this.webComunic.valores.length > 0 ? this.webComunic.valores : null;
  }

  /**
  * @description
  * Mostrar Notificaciones en la vista rápida
  * @param valores Array de datos donde están los datos de las notificaciones
  * @param numero Diferencia a la función del template y determina que nos traemos
  * (1 --> fecha 2 --> descripcion  3 --> enlace)
  */
  public recogerValorNotificaciones(valor: any, numero: number) : any {
    let etiquetas = new Array<Xmlfields>();
    for(let i = 0; i < this.webservicesParseVista.length; i++){
        const element = this.webservicesParseVista[i];
        if(element.code == CODE_WEBSERVICES.NOTCOMVIGWSI) {
            etiquetas = _.cloneDeep(element.etiquetas);
        }
    }
    for(let i = 0; i < etiquetas.length; i++){
        for(let x = 0; x < valor.length; x++){
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.tipus && numero == 5){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.datacreacio && numero == 1){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return this.formatFecha(valor[x].valor);
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.titol && numero == 2){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.tipus && numero == 3){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.estat && numero == 4){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
        }
    }
  }

  /**
  * @description
  * Nos devuelve los el array de valores de las queixas para meterlos en el carrusel
  */
  public valoresQueixas(): any {
    return this.webQueixas.valores != null && this.webQueixas.valores.length > 0 ? this.webQueixas.valores : null;
  }

  /**
  * @description
  * Mostrar Queixas en la vista rápida
  * @param valores Array de datos donde están los datos de las queixas
  * @param numero Diferencia a la función del template y determina que nos traemos
  */
  public recogerValorQuejas(valor: any, numero: number) : any {
    let etiquetas = new Array<Xmlfields>();
    for(let i = 0; i < this.webservicesParseVista.length; i++){
        const element = this.webservicesParseVista[i];
        if(element.code == CODE_WEBSERVICES.QUEIXESBYNIF) {
            etiquetas = _.cloneDeep(element.etiquetas);
        }
    }
    for(let i = 0; i < etiquetas.length; i++){
        for(let x = 0; x < valor.length; x++){
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.datacreacio && numero == 1){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return this.formatFecha(valor[x].valor);
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.desccurta && numero == 2){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.estat && numero == 3){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
        }
    }
  }

  /**
  * @description
  * Nos devuelve el array de valores de los ws empadronamiento para meterlos en el carrusel
  */
  public valoresEmpadronamiento(): any {
    for (let index = 0; index < this.webservicesParseVista.length; index++) {
        const element = this.webservicesParseVista[index];
        if (element.code == CODE_WEBSERVICES.VRWSPASHABITADADESWSI) {
            return element.valores != null && element.valores.length > 0 ? element.valores : null;
        }
    }
    return null;
  }

  /**
  * @description
  * Pasamos el dato específico de los datos empadronamiento en el carrusel
  * @param valores Array de datos donde están los datos de empadronamiento
  * @param numero Diferencia a la función del template y determina que nos traemos.
  */
  public recogerEmpadronamiento(valor: any, numero: number) : any {
      let etiquetas = new Array<Xmlfields>();
      for(let i = 0; i < this.webservicesParseVista.length; i++){
          const element = this.webservicesParseVista[i];
          if(element.code == CODE_WEBSERVICES.VRWSPASHABITADADESWSI) {
              etiquetas = _.cloneDeep(element.etiquetas);
          }
      }
      for(let i = 0; i < etiquetas.length; i++){
          for(let x = 0; x < valor.length; x++){
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.individual && numero == 1){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.colectivo && numero == 2){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
          }
      }
  }

  /**
    * @description
    * Nos devuelve los el array de valores de los borradores para meterlos en el carrusel
    */
  public valoresEsborranys(): any {
    for (let index = 0; index < this.webservicesParseVista.length; index++) {
        const element = this.webservicesParseVista[index];
        if (element.code == CODE_WEBSERVICES.ESBORRANYSTRAMITS) {  
            return element.valores != null && element.valores.length > 0 ? element.valores : null;
        }
    }
    return null;
  }

  /**
  * @description
  * Pasamos el dato específico de los esborranys en el carrusel
  * @param valores Array de datos donde están los datos de los esborranys
  * @param numero Diferencia a la función del template y determina que nos traemos.
  */
  public recogerValoresEsborranys(valor: any, numero: number) : any {
      let etiquetas = new Array<Xmlfields>();
      for(let i = 0; i < this.webservicesParseVista.length; i++){
          const element = this.webservicesParseVista[i];
          if (element.code == CODE_WEBSERVICES.ESBORRANYSTRAMITS) {  
              etiquetas = _.cloneDeep(element.etiquetas);
          }
      }
      for(let i = 0; i < etiquetas.length; i++){
          for(let x = 0; x < valor.length; x++){
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.nomesborrany && numero == 1){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.paramslinkesbregtel && numero == 2){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.descesborrany && numero == 3){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
              if(etiquetas[i].code == ETIQUETAS.NOMBRE.dataesborrany && numero == 4){
                  if(etiquetas[i].numorder == valor[x].numorder){
                      return valor[x].valor;
                  }
              }
          }
      }
  }

  /**
  * @description
  * Nos devuelve los el array de valores de los tramites para meterlos en el carrusel
  */
  public valoresTramitesPendientes(): any {
    for (let index = 0; index < this.webservicesParseVista.length; index++) {
      const element = this.webservicesParseVista[index];
      //if (element.code == CODE_WEBSERVICES.TRAMITVISTARAPIDA) {
      if (element.code == CODE_WEBSERVICES.TRAMITSPORTALCIUTADA || 
        element.code == CODE_WEBSERVICES.TRAMITSPORTALEMPRESA || 
        element.code == CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR) {  
        return element.valores != null && element.valores.length > 0 ? element.valores : null;
      }
    }
    return null;
  }

  /**
  * @description
  * Pasamos el dato específico de los trámites en el carrusel
  * @param valores Array de datos donde están los datos de los trámites
  * @param numero Diferencia a la función del template y determina que nos traemos.
  */
  public recogerValoresTramites(valor: any, numero: number) : any {
    let etiquetas = new Array<Xmlfields>();
    for(let i = 0; i < this.webservicesParseVista.length; i++){
        const element = this.webservicesParseVista[i];
        if (element.code == CODE_WEBSERVICES.TRAMITSPORTALCIUTADA || 
          element.code == CODE_WEBSERVICES.TRAMITSPORTALEMPRESA || 
          element.code == CODE_WEBSERVICES.TRAMITSPORTALPROVEIDOR) {
          etiquetas = _.cloneDeep(element.etiquetas);
        }
    }
    for(let i = 0; i < etiquetas.length; i++){
        for(let x = 0; x < valor.length; x++){
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.numtramittelem && numero == 2){
              if(etiquetas[i].numorder == valor[x].numorder){
                //window.open(valor[x].valor, '_blank');
                let isotvtram = this.enlacesTamitesGTToComun(valor[x].valor);
                window.open(isotvtram, '_blank');
              }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.desctramit && numero == 1){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.detTramit && numero == 3){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
        }
    }
  }

  /**
  * @description
  * Nos devuelve el array de valores de los Altres serveis para meterlos en el carrusel
  */
  public valoresAltresServeis(): any {
    for (let index = 0; index < this.webservicesParseVista.length; index++) {
      const element = this.webservicesParseVista[index];
      if (element.code == CODE_WEBSERVICES.ALTRESSERVEISCIUTADA || 
        element.code == CODE_WEBSERVICES.ALTRESSERVEISEMPRESA || 
        element.code == CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR) {  
        return element.valores != null && element.valores.length > 0 ? element.valores : null;
      }
    }
    return null;
  }

  /**
  * @description
  * Pasamos el dato específico de los altres serveis en el carrusel
  * @param valores Array de datos donde están los datos de los trámites
  * @param numero Diferencia a la función del template y determina que nos traemos.
  */
  public recogerValoresAltres(valor: any, numero: number) : any {
    let etiquetas = new Array<Xmlfields>();
    for(let i = 0; i < this.webservicesParseVista.length; i++){
        const element = this.webservicesParseVista[i];
        if (element.code == CODE_WEBSERVICES.ALTRESSERVEISCIUTADA || 
          element.code == CODE_WEBSERVICES.ALTRESSERVEISEMPRESA || 
          element.code == CODE_WEBSERVICES.ALTRESSERVEISPROVEIDOR) {
          etiquetas = _.cloneDeep(element.etiquetas);
        }
    }
    for(let i = 0; i < etiquetas.length; i++){
        for(let x = 0; x < valor.length; x++){
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.urlServei && numero == 2){
              if(etiquetas[i].numorder == valor[x].numorder){
                  return valor[x].valor;
              }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.descripcio && numero == 1){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
            if(etiquetas[i].code == ETIQUETAS.NOMBRE.detall && numero == 3){
                if(etiquetas[i].numorder == valor[x].numorder){
                    return valor[x].valor;
                }
            }
        }
    }
  }

  /**
  * @description
  * Cargamos en la vista rápida los datos de los grafos facturas y contratos (separados por ser lentos)
  * @param code code del WS (Facturas o Contratos, según el usuario seleccione).
  */
  public viewWSCargaLenta(wscode : string){
    let ws = new Wsdefs();
    let datosWs = new Array<WebservicesParse>();

    if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
        this.loadingfactures = true;
        this.viewfactures = true;
    }
    if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
        this.loadingContractes = true;
        this.viewContractes = true;
    }

    let existe : boolean = false;

    for(let i = 0; i < this.wsdefs.length; i++){
        if(this.wsdefs[i].code === wscode){
            ws = _.cloneDeep(this.wsdefs[i]);
        }
    }

    let webser =  this.asignacionAtribObject(ws);
    this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).subscribe(data => {
        datosWs = _.cloneDeep(data);
        for(let x = 0; x < this.webservicesParseVista.length; x++){
            if(this.webservicesParseVista[x].code == datosWs[0].code){
                existe = true;
            }
        }

        if(!existe){
            this.webservicesParseVista.push(datosWs[0]);
            this.webservicesParse.push(datosWs[0]);
        }

        let numws : number = 0;
        for(let i = 0; i < this.webservicesParseVista.length; i++){
            numws++;
            switch(this.webservicesParseVista[i].code) {
                case CODE_WEBSERVICES.PASFACTULTANYWSI: {
                    this.vistaRapidaObj.totFacturas = 0;
                    this.vistaRapidaObj.totFacPag = 0;
                    this.vistaRapidaObj.totFacPend = 0;
                    this.vistaRapidaObj.totFacIncid = 0;
                    this.vistaRapidaObj.totImportFact = 0;
                    this.vistaRapidaObj.factpagat = 0;
                    this.vistaRapidaObj.factincid = 0;
                    this.vistaRapidaObj.factpende = 0;
                    let numorden : number = 0;
                    if(this.webservicesParseVista[i].valores != null){
                      this.vistaRapidaObj.totFacturas = this.webservicesParseVista[i].valores.length;
                    }
                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.PASFACTULTANYWSI, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                    break; 
                }

                case CODE_WEBSERVICES.NIOSDISPONIBLESPROV: {
                    let numorden : number = 0;
                    this.vistaRapidaObj.totContra = 0;
                    this.vistaRapidaObj.totImportContr = 0;
                    this.vistaRapidaObj.contImporFac = 0;
                    this.vistaRapidaObj.contImporNotFac = 0;
                    this.calculoImportes(this.webservicesParseVista, CODE_WEBSERVICES.NIOSDISPONIBLESPROV, i, numorden, numws, ETIQUETAS.NOMBRE.importtotal);
                    if(this.webservicesParseVista[i].valores != null){
                        this.vistaRapidaObj.totContra = this.webservicesParseVista[i].valores.length;
                    }
                    this.vistaRapidaObj.contImporFac = this.vistaRapidaObj.totImportContr - this.vistaRapidaObj.contImporNotFac;
                    break;
                }
            }
        }
            
        if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
            this.loadingfactures = false;
        }
        if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
            this.loadingContractes = false;
        }

    }, (error: any)=> {
        this.textContacte = true;
        console.log("Error: " + error);
        if(wscode === CODE_WEBSERVICES.PASFACTULTANYWSI){
            this.loadingfactures = false;
        }
        if(wscode === CODE_WEBSERVICES.NIOSDISPONIBLESPROV){
            this.loadingContractes = false;
        }
    });
  }

  /**
  * @description
  * nos redirige a una web para cambiar los datos generales del usuario en vista rápida
  */
  enlaceDadesContacte(){
    let url : string = "";
    let urlnif: string = "";
    let urltoken: string = "";
    for(let i = 0; i < this.fieldLinks.length; i++){
        if(this.fieldLinks[i].code === TIPO_DATO.CANVICONTACTLINK){
            url = this.fieldLinks[i].url;
        }
    }

    urlnif = url.replace('{{FI4_IDNUMBER}}', this.nif);
    urltoken = urlnif.replace('{{FI4TOKEN}}', this.validToken.token);
    window.open(urltoken, "_blank");
  }

  /**
  * @description
  * nos redirige a una web para visualizar notif/comun del usuario en vista rápida
  */
  enlaceNotificaciones(): string {
    let url : string = "";
    for(let i = 0; i < this.fieldLinks.length; i++){
        if(this.fieldLinks[i].code === TIPO_DATO.ENOTUM){
          return url = this.fieldLinks[i].url;
        }
    }
    return url;
  }

  /**
  * @description
  * Gestión de la barra de menu al cerrarse para dispositivos móviles
  */
  gestionMenuMovilCerrar(){
    var menuCerrar = document.getElementById("menumovilCerrar");
    let menuAbrir = document.getElementById("collapseOne");
    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
          menuAbrir.style.display = "none";
          menuCerrar.style.display = "block";
      }else{
          menuAbrir.style.display = "";
          menuCerrar.style.display = "";
      }
    }
  }

  /**
  * @description
  * Gestión de la barra de menu al abrirse para dispositivos móviles
  */
  gestionMenuMovilAbrir(){
    var menuCerrar = document.getElementById("menumovilCerrar");
    let menuAbrir = document.getElementById("collapseOne");
    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
          menuAbrir.style.display = "block";
          menuCerrar.style.display = "none";
      }else{
          menuAbrir.style.display = "";
          menuCerrar.style.display = "";
      }
    }
  }

  /**
  * @description
  * Enlace de ayudans millorar
  */
  alludans() {

    let id = "";
    let dboid = localStorage.getItem(STORAGE.DBOID);

    switch(this.rol){
      case EXTERNAL_ROL.PAGES.ciudadano: {
        id = "4";
        break;
      }
      case EXTERNAL_ROL.PAGES.empresa: {
        id = "5";
        break;
      }
      case EXTERNAL_ROL.PAGES.proveedor: {
        id = "6";
        break;
      }
    }
    this.repositoryService.doGet(PETICIONES.webservice.doGet + "/" + id + "/" + dboid).subscribe(result => {
      let urlMillor =  new MensajeLogin();
      urlMillor = _.cloneDeep(result);
      if(urlMillor.missatges == null){
        this.errorCargaWS('WARNINGS.error_ws');
      }else{
        let lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
        if(lang === 'es'){
          let ayudaCast = urlMillor.missatges.toString() + "&lang=es";
          window.open(ayudaCast, '_blank');
        }else{
          let ayudaCat = urlMillor.missatges.toString() + "&lang=ca";
          window.open(ayudaCat, '_blank');
        }
      }
    }, error => {
      this.errorCargaWS('WARNINGS.error_ws');
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  *Guardamos un comentario
  * @param text
  */
  public enviarcomentario(text: string){
    let comentario = new Comments();
    comentario.dboid = localStorage.getItem(STORAGE.DBOID) ?? "";
    comentario.name = localStorage.getItem(STORAGE.USUARIO) ?? "";
    comentario.text = text;
    comentario.nif = this.nif;
    comentario.email = this.validToken.email;
    comentario.admin = 1;
    this.commentsService.postComments(comentario).subscribe((res: any) => {
        console.log(res);
        this.comment.text = "";
    }, (error: any) => {
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Desabilita el boton enviar comentarios si no hay comentario
  */
  public deshabilitar():boolean{
    if(this.comment.text === null || this.comment.text === "" ||  this.comment.text === undefined){
    return true;
    }
    return false;
  }

  public botonpruebaAsistente(){
    this.numeroMensajes = 0;
  }

  /**
  * @description
  * Nos traemos todos los trámites disponibles en la Seu y hacemos busqueda en carpeta (ws, campos y datos)
  */
  public cargarTramitsYCarpeta(){

    this.loadingTramite = true;
    this.isTramite = true;
    this.numtramitbusqueda = 0;
    let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    this.buscaTramAll = new Array<BuscadorTramites>();

    if(this.tramitsbusqueda != ""){
      this.repositoryService.doGet(PETICIONES.accesTotsTramits.buscaAllTramits + "/" + this.tramitsbusqueda + "/" + idioma).subscribe(res => {
          this.buscaTramAll = _.cloneDeep(res);

          if(this.buscaTramAll != null){
            this.numtramitbusqueda = this.buscaTramAll.length;
            for(let i = 0; i < this.buscaTramAll.length; i++){

                if(this.buscaTramAll[i].titolEs.length <= 0){
                    this.buscaTramAll[i].titolEs = _.cloneDeep(this.buscaTramAll[i].titol);
                }

                if(this.buscaTramAll[i].descripcioCurtaEs.length <= 0){
                    this.buscaTramAll[i].descripcioCurtaEs = _.cloneDeep(this.buscaTramAll[i].descripcioCurta);
                }
                
                this.buscaTramAll[i].tramitCorreo =  false;
                this.buscaTramAll[i].tramitPresencial =  false;
                this.buscaTramAll[i].tramitTelematic = false;

                for(let x = 0; x < this.buscaTramAll[i].canals.length; x++){
                    if(this.buscaTramAll[i].canals.length > 0){
                        if(this.buscaTramAll[i].canals[x].charAt(0) == "C"){
                            this.buscaTramAll[i].tramitCorreo = true;
                        }

                        if(this.buscaTramAll[i].canals[x].charAt(0) == "P"){
                            this.buscaTramAll[i].tramitPresencial = true;
                        }

                        if(this.buscaTramAll[i].canals[x].charAt(0) == "T"){
                            this.buscaTramAll[i].tramitTelematic = true;
                        }
                    }
                }
            }
          }
      }, error => {
          this.loadingTramite = false;
          console.log("Error: " + error);
      });

      if(!this.fullBusca){

          let wsParse : Wsdefs[] = new Array<Wsdefs>();
          for(let i = 0; i < this.wsdefs.length; i++){
              for(let x = 0; x < this.webservicesParse.length; x++){
                  if(this.wsdefs[i].code === this.webservicesParse[x].code){
                      wsParse.push(this.wsdefs[i]);
                  }
              }
          }
          
          let wsdefsincarga : Wsdefs[] = new Array<Wsdefs>();
          for(let i = 0; i < this.wsdefsrol.length; i++){
              let aux: boolean = true;
              for(let x = 0; x < wsParse.length; x++){
                  if(this.wsdefsrol[i].code === wsParse[x].code){
                      aux = false;
                  }
              }
              if(aux){
                  wsdefsincarga.push(this.wsdefsrol[i]);
              }
          }

          let webser = this.asignacionAtribArrayObject(wsdefsincarga);
          let wsbusquedaCompleta = new Array<WebservicesParse>();
          this.repositoryService.doPost(PETICIONES.webservice.doPost, webser).subscribe(data => {
              
              this.formatTipoWS(data);
              wsbusquedaCompleta = _.cloneDeep(data);

              let auxparseBusca: WebservicesParse[] = new Array<WebservicesParse>();
              for(let i = 0; i < this.wsdefs.length; i++){
                  for(let x = 0; x < this.webservicesParse.length; x++){
                      if(this.wsdefs[i].code === this.webservicesParse[x].code){
                          if(this.wsdefs[i].quickview != 1){
                              auxparseBusca.push(this.webservicesParse[x]);
                          }
                      }
                  }
              }

              for(let i = 0; i < wsbusquedaCompleta.length; i++){
                  auxparseBusca.push(wsbusquedaCompleta[i]);
                  this.webservicesParse.push(wsbusquedaCompleta[i]);
              }

              this.busquedaCampos(idioma, auxparseBusca);
              this.tramitsbusqueda = "";
              this.fullBusca = true;
              this.loadingTramite = false;
          }, error => {
              this.tramitsbusqueda = "";
              this.loadingTramite = false;
              console.log("Error: " + error);
          });

      }else{

          if(this.fullBusca){
              let auxparseBusca: WebservicesParse[] = new Array<WebservicesParse>();
              for(let i = 0; i < this.wsdefs.length; i++){
                  for(let x = 0; x < this.webservicesParse.length; x++){
                      if(this.wsdefs[i].code === this.webservicesParse[x].code){
                          if(this.wsdefs[i].quickview != 1){
                              auxparseBusca.push(this.webservicesParse[x]);
                          }
                      }
                  }
              }
              this.busquedaCampos(idioma, auxparseBusca);
              this.tramitsbusqueda = "";
              this.loadingTramite = false;
          }else{
              this.busquedaCampos(idioma, this.webservicesParseBuscadorAux);
              this.tramitsbusqueda = "";
              this.loadingTramite = false;
          }
      }

    }else{
      this.buscaTramAll = new Array<BuscadorTramites>();
      this.webservicesParseBuscador = new Array<WebservicesParse>();
      this.tramitsbusqueda = "";
      this.loadingTramite = false;
    }
  }


  public busquedaCampos(idioma: string, allwsparse: WebservicesParse[]) {
  
    this.webservicesParseBuscador = new Array<WebservicesParse>();
    let webservicesParseBuscador = new Array<WebservicesParse>();
    let text : string = this.tramitsbusqueda
    text != null && text != undefined ? _.deburr(_.trim(text).toLocaleLowerCase()) : "";
    text = _.deburr(_.trim(text));
    
    for(let i = 0; i < allwsparse.length; i++){
      let wsparseaux= new WebservicesParse();
      let xmlfields = new Array<Xmlfields>();
      if(allwsparse[i].valores != null){
        for(let x = 0; x < allwsparse[i].etiquetas.length; x++){
            let campo = _.deburr(_.trim(idioma == "ca" ?  allwsparse[i].etiquetas[x].cat : allwsparse[i].etiquetas[x].esp).toLocaleLowerCase());
            if(text != "" && _.includes(campo, text.toLocaleLowerCase())) {
                xmlfields.push(allwsparse[i].etiquetas[x]);
                wsparseaux.code = _.cloneDeep(allwsparse[i].code);
                wsparseaux.cat = _.cloneDeep(allwsparse[i].cat);
                wsparseaux.esp = _.cloneDeep(allwsparse[i].esp);
                wsparseaux.etiquetas = _.cloneDeep(xmlfields);
                webservicesParseBuscador.push(wsparseaux);
            }
        }
        let registro = _.deburr(_.trim(idioma == "ca" ? allwsparse[i].cat : allwsparse[i].esp).toLocaleLowerCase());
        if(text != "" && _.includes(registro, text.toLocaleLowerCase())) {
            let auxbool: boolean = true;
            for(let x = 0; x < webservicesParseBuscador.length; x++){
                if(webservicesParseBuscador[x].code === allwsparse[i].code){
                    auxbool = false;
                }
            }
            if(auxbool){
                let wsparseaux= new WebservicesParse();
                wsparseaux = _.cloneDeep(allwsparse[i]);
                wsparseaux.etiquetas = _.cloneDeep(new Array<Xmlfields>())
                webservicesParseBuscador.push(wsparseaux);
            }
        }
      }
    }

    for(let i = 0; i < allwsparse.length; i++){
      if(allwsparse[i].valores != null){
        let wsparseaux= new WebservicesParse();
        let xmlfields = new Array<Xmlfields>();
        for(let x = 0; x < allwsparse[i].valores.length; x++){
          for(let y = 0; y < allwsparse[i].valores[x].length; y++){
            let valor = _.deburr(_.trim(allwsparse[i].valores[x][y].valor).toLocaleLowerCase());
            let numorder = allwsparse[i].valores[x][y].numorder;
            if(text != "" && _.includes(valor, text.toLocaleLowerCase())) {
              for(let t = 0; t < allwsparse[i].etiquetas.length; t++){
                if(allwsparse[i].etiquetas[t].numorder === numorder){
                  if(allwsparse[i].etiquetas[t].fieldtypeId.format === 0){
                    xmlfields.push(allwsparse[i].etiquetas[t]);
                    wsparseaux.code = _.cloneDeep(allwsparse[i].code);
                    wsparseaux.cat = _.cloneDeep(allwsparse[i].cat);
                    wsparseaux.esp = _.cloneDeep(allwsparse[i].esp);
                    wsparseaux.etiquetas = _.cloneDeep(xmlfields);
                  }
                }
              }
            }
          }
        }
        if(wsparseaux.code != undefined){
            let xmlfieldsaux = new Array<Xmlfields>();
            var lookupObject : { [key: string]: Xmlfields } = {};
            for(var x in wsparseaux.etiquetas) {
                lookupObject[wsparseaux.etiquetas[x].code] = wsparseaux.etiquetas[x];
            }
        
            for(x in lookupObject) {
                xmlfieldsaux.push(lookupObject[x]);
            }
            wsparseaux.etiquetas = _.cloneDeep(xmlfieldsaux);
            webservicesParseBuscador.push(wsparseaux);
        }
      }
    }

    var lookupObjecto: { [key: string]: WebservicesParse } = {};
    for(var i in webservicesParseBuscador) {
        lookupObjecto[webservicesParseBuscador[i].code] = webservicesParseBuscador[i];
    }

    for(i in lookupObjecto) {
        this.webservicesParseBuscador.push(lookupObjecto[i]);
    }

    if(idioma == "ca"){
        this.webservicesParseBuscador = _.orderBy(this.webservicesParseBuscador, 'cat');
    }else{
        this.webservicesParseBuscador = _.orderBy(this.webservicesParseBuscador, 'esp');
    }

    console.log(this.webservicesParseBuscador);
  }

  /**
  * @description
  * Escondemos los tramites de la seu y mostramos la vistarápida o ws segun seleccionemos
  */
  public tramiteout(){
    this.isTramite = false;
    this.vistaRapida = true;
  }

  public createObject<K extends string, T extends {}>(keyName: K, details: T) {
    return { [keyName]: details } as Record<K, T>;
  }

  /**
  * @description
  * Exportamos los datos del ws a un documento csv
  */
  public exportarDatos(): number{

    let numreg = 0;
    for(let y = 0; y < this.webserviceVista.valores[0].length; y++){
      let numorder = this.webserviceVista.valores[0][y].numorder;
      for(let t = 0; t < this.webserviceVista.etiquetas.length; t++){
        if(this.webserviceVista.etiquetas[t].numorder === numorder){
          if(this.webserviceVista.etiquetas[t].fieldtypeId.format === 0){
            numreg++;
          }
        }
      }
    }

    let arraytit = new Array();
    let stringjson = "";
    let jsonPrueba = "";
    for(let x = 0; x < this.webserviceVista.valores.length; x++){
      for(let y = 0; y < this.webserviceVista.valores[x].length; y++){
        let numorder = this.webserviceVista.valores[x][y].numorder;
        for(let t = 0; t < this.webserviceVista.etiquetas.length; t++){
          if(this.webserviceVista.etiquetas[t].numorder === numorder){
            if(this.webserviceVista.etiquetas[t].fieldtypeId.format === 0){

              let clave = "";
              let valor = this.webserviceVista.valores[x][y].valor;

              if(this.idioma === DEFAULT_LANG){
                clave = this.webserviceVista.etiquetas[t].cat;
              }else{
                clave = this.webserviceVista.etiquetas[t].esp;
              }

              let dynamicObject = new Object();
              dynamicObject = this.createObject(clave, valor);
              dynamicObject.toString();

              if(numreg == 1){
                jsonPrueba = JSON.stringify(dynamicObject);
                stringjson = stringjson.concat(jsonPrueba);
              }else{
                if(y == 0){
                  let change = /\}/gi;
                  jsonPrueba = JSON.stringify(dynamicObject).replace(change, ",");
                  stringjson = stringjson.concat(jsonPrueba);
                }else if(y == numreg -1){
                  let change = /\{/gi;
                  jsonPrueba = JSON.stringify(dynamicObject).replace(change, "");
                  stringjson = stringjson.concat(jsonPrueba);
                }else{
                  let change1 = /\{/gi;
                  let change2 = /\}/gi;
                  jsonPrueba = JSON.stringify(dynamicObject).replace(change1, "").replace(change2, ",");
                  stringjson = stringjson.concat(jsonPrueba);
                }
              }
              
              arraytit.push(clave);
            }
          }
        }
      }
    }

    if(numreg == 0){
      return 0;
    }else{
      const arraytitulos = arraytit.slice(0, numreg);

      let jsoncorch = "[" + stringjson + "]";
      let change = /\}{/gi;
      let salto = /\\n/gi;
      let puntocoma = /\;/gi;
            
      let json = jsoncorch.replace(change, "},{");
      json = json.replace(salto, ". ");
      json = json.replace(puntocoma, ",");
  
      let titulo = "";
      let fecha = Utils.formatofecha();
      if(this.idioma === DEFAULT_LANG){
          titulo = Utils.formatoFirstCase(this.webserviceVista.cat);
      }else{
          titulo = Utils.formatoFirstCase(this.webserviceVista.esp);
      }

      let nombrefichero = this.nif + titulo + fecha;
      this.downloadFile(json, nombrefichero, arraytitulos);
      return 1;
    }
  }

  /**
  * @description
  * Ganeración de ldcumento GSV con los datos de las tablas
  */
  downloadFile(data: any, filename='data', arraytitulos:any) {
    let csvData = this.ConvertToCSV(data, arraytitulos);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  /**
  * @description
  * Conversion de los datos de las tablas para pasarlos al documento CSV, añadimos titulos en cabezera.
  */
  ConvertToCSV(objArray: any, headerList: any) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'registro;';

    for (let index in headerList) {
        row += headerList[index] + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
        let line = (i+1)+'';
        for (let index in headerList) {
          let head = headerList[index];

            line += ';' + array[i][head];
        }
        str += line + '\r\n';
    }
    return str;
  }

  /**
  * @description
  * Redirigimos el videotutorial dependiendo de que carpeta seleccionaael usuario
  */
  public videoTutorial(){
    switch(this.carpeta){
      case EXTERNAL_PAGES.PAGES.ciudadano: {
        window.open(this.REUS_TUTORIAL, '_blank');
        break; 
      }
      case EXTERNAL_PAGES.PAGES.empresa: {
        window.open(this.REUS_TUTORIAL, '_blank');
        break; 
      }
      case EXTERNAL_PAGES.PAGES.proveedor: {
        if(this.idioma != 'ca'){
          window.open(this.REUS_TUTORIAL_PROV_ES, '_blank');
        }else{
          window.open(this.REUS_TUTORIAL_PROV_CA, '_blank');
        }
        break;
      }
    }
  }

  build() {
  }

  /**
  * @description
  * Recogemos el id del trámite y lo redireccionamos paraque el usuario entre sin tener 
  * que identificarse
  */
  public tramiteDirecto(idtramit: string[]){
    if(idtramit.length > 0){
      let urltramit =  this.enlacesTamitesGTToComun(idtramit[0]);
      window.open(urltramit, '_blank');
    }
  }

  /**
  * @description
  * Recogemos el valor del string del icono del filedlink y le pasamos la ruta a la vista
  * para que lo cargue
  */
  public seleccionIcono(tipo:String):String{
    return BASE_HREF + '/assets/images/icons/' + tipo + '.svg';
  }

  /**
  * @description
  * Recogemos la url de los trámites y dependiendo de que tipo sea de damos una redirección 
  * con validación
  */
  enlacesTamitesGTToComun(url:string): string{
    
    let servicios = PARAMS_OVT.SUBORGANISMO + "/" + PARAMS_OVT.SERVICIO ;
    let isotvtram = url.includes(servicios);
    if(isotvtram){

      let urlDatoRedir = url.includes('?type=');
      let urfraccionar = url.includes('?tr=');

      if(urlDatoRedir){
        let position = url.indexOf('=');
        let datoRedir = url.substring(position + 1);
        switch(datoRedir){
          case "BIF": {
            return this.accederGTTGeneral("PREL", 'BIF');
          }
          case "SIV": {
            return this.accederGTTGeneral("PREL", 'SIV');
          }
          case "JPT": {
            return this.accederGTTGeneral("PREL", 'JPT');
          }
          case "FR": {
            return this.accederGTTGeneral("PREL", 'FR');
          }
          default: { 
            return url;
          } 
        }

      }else if(urfraccionar){
        let position = url.indexOf('=');
        let datoRedir = url.substring(position + 1);
        switch(datoRedir){
          case "ejecutiva": {
            return this.accederGTTGeneral("PRELFRACEJE", '');
          }
          case "voluntaria": {
            return this.accederGTTGeneral("PRELFRACVOLU", '');
          }
          default: { 
            return url;
          } 
        }
      }else{
        let position = url.indexOf(servicios);
        let recogerdata = url.substring(position + servicios.length);
        switch(recogerdata){
          case "/mis-datos/mis-datos": {
            return this.accederGTTGeneral("PERSONA", '');
          }
          case "/impuesto-matriculacion": {
            return this.accederGTTGeneral("AV", '');
          }
          case "/plusvalia": {
            return this.accederGTTGeneral("IIVTNU", '');
          }
          case "/gestionar-multa": {
            return this.accederGTTGeneral("LOCMULTA", '');
          }
          default: { 
            return url;
          } 
        }
      }
    }else{
      let isotvtram = url.includes('https://ovt.reus.cat');
      if(isotvtram){
        let position = url.indexOf('=');
        let clave = url.substring(position + 1);
        return this.accederGTTGeneral(clave, '');
      }else{

        let istramnomal = url.includes('login.jsp?formulari=');
        if(istramnomal){
          let position = url.indexOf('=');
          let formulari = url.substring(position + 1);

          if(/^[0-9]*$/.test(formulari)){
            let nif = '&nif=';
            let token = '&token=';
            let idioma = '&idioma=';
            let tipidioma = _.cloneDeep(this.idioma);
            if(tipidioma == OPTIONAL_LANG){
              tipidioma = _.cloneDeep('esp');
            }else{
              tipidioma = _.cloneDeep('cat');
            }
            let urlvalid =  "https://serveis.reus.cat/registre/jsps/login.jsp?formulari=" + formulari + nif + this.nif + token + this.validToken.token + idioma + tipidioma;
            return urlvalid;
          }else{
            return url;
          }
          
        }else{
          return url;
        }
      }
      
    }
  }

  accederGTTCabecera(){
    let redireccion = this.accederGTTGeneral("", "");
    window.open(redireccion, '_blank');
  }

  decodeHtmlEntities(value: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = value;
    return txt.value;
  }

}
